webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4trT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mix+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb22511e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("CPyU")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ArticleNavigationBar = ({
  props: ['logoURL', 'title', 'page', 'companyName', 'width'],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['zoomEnabled', 'contentsEnabled', 'searchEnabled', 'languagesEnabled', 'downloadEnabled', 'printEnabled', 'rightToLeft', 'companyLogo', 'downloadPath', 'showContents', 'showLanguages', 'showSearch', 'isZoomed', "isArticle",
  // "showArticles",
  "articlesEnabled", "articleFontSize"]), {
    divider: function divider() {
      if (this.rightToLeft) return 'chevron-left';
      return 'chevron-right';
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleLanguages: 'TOGGLE_LANGUAGES',
    toggleZoom: 'TOGGLE_ZOOM',
    toggleSearch: 'TOGGLE_SEARCH',
    increaseArticleFontSize: 'INCREASE_ARTICLE_FONT_SIZE',
    decreaseArticleFontSize: 'DECREASE_ARTICLE_FONT_SIZE'
  }), {
    toggleArticles: function toggleArticles() {
      var e = document.getElementById('article-menu-sm');
      if (e.style.display == 'none') {
        e.style.display = 'block';
      } else {
        e.style.display = 'none';
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4653b7f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleNavigationBar.vue
var ArticleNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),(_vm.isArticle)?_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[_c('li',{staticClass:"nav-bar__link nav_link_hidden",on:{"click":function($event){_vm.toggleArticles()}}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1),_vm._v(" "),_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.increaseArticleFontSize}},[_c('feather-icon',{attrs:{"icon":"zoom-in"}})],1),_vm._v(" "),_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.decreaseArticleFontSize}},[_c('feather-icon',{attrs:{"icon":"zoom-out"}})],1)])]):_vm._e()])])}
var ArticleNavigationBar_staticRenderFns = []
var ArticleNavigationBar_esExports = { render: ArticleNavigationBar_render, staticRenderFns: ArticleNavigationBar_staticRenderFns }
/* harmony default export */ var components_ArticleNavigationBar = (ArticleNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/ArticleNavigationBar.vue
function ArticleNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("4trT")
}
var ArticleNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticleNavigationBar___vue_template_functional__ = false
/* styles */
var ArticleNavigationBar___vue_styles__ = ArticleNavigationBar_injectStyle
/* scopeId */
var ArticleNavigationBar___vue_scopeId__ = "data-v-4653b7f8"
/* moduleIdentifier (server only) */
var ArticleNavigationBar___vue_module_identifier__ = null
var ArticleNavigationBar_Component = ArticleNavigationBar_normalizeComponent(
  ArticleNavigationBar,
  components_ArticleNavigationBar,
  ArticleNavigationBar___vue_template_functional__,
  ArticleNavigationBar___vue_styles__,
  ArticleNavigationBar___vue_scopeId__,
  ArticleNavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticleNavigationBar = (ArticleNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleMenu.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ArticleMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["articles", "articleLink", "currentArticle"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({}), Object(vuex_esm["b" /* mapActions */])(["goToArticle"]))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd53e5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleMenu.vue
var ArticleMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article-menus"}},[_c('div',{attrs:{"id":"article-menu"}},[_c('ul',{attrs:{"id":"article-list"}},_vm._l((_vm.articles),function(article,index){return _c('li',{key:index,staticClass:"article-list",class:{active: article.articleIndex == _vm.currentArticle.articleIndex},on:{"click":function($event){_vm.goToArticle(index)}}},[_vm._v("\n          "+_vm._s(article.title)+"\n      ")])}))]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"article-menu-sm"}},[_c('ul',{attrs:{"id":"article-list"}},_vm._l((_vm.articles),function(article,index){return _c('li',{key:index,staticClass:"article-list",class:{active: article.articleIndex == _vm.currentArticle.articleIndex},on:{"click":function($event){_vm.goToArticle(index)}}},[_vm._v("\n          "+_vm._s(article.title)+"\n      ")])}))])])}
var ArticleMenu_staticRenderFns = []
var ArticleMenu_esExports = { render: ArticleMenu_render, staticRenderFns: ArticleMenu_staticRenderFns }
/* harmony default export */ var components_ArticleMenu = (ArticleMenu_esExports);
// CONCATENATED MODULE: ./src/components/ArticleMenu.vue
function ArticleMenu_injectStyle (ssrContext) {
  __webpack_require__("P7QL")
}
var ArticleMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticleMenu___vue_template_functional__ = false
/* styles */
var ArticleMenu___vue_styles__ = ArticleMenu_injectStyle
/* scopeId */
var ArticleMenu___vue_scopeId__ = "data-v-2fd53e5e"
/* moduleIdentifier (server only) */
var ArticleMenu___vue_module_identifier__ = null
var ArticleMenu_Component = ArticleMenu_normalizeComponent(
  ArticleMenu,
  components_ArticleMenu,
  ArticleMenu___vue_template_functional__,
  ArticleMenu___vue_styles__,
  ArticleMenu___vue_scopeId__,
  ArticleMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticleMenu = (ArticleMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticlePage.vue

//
//
//
//
//
//
//
//
//




/* harmony default export */ var ArticlePage = ({
  components: {

    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["currentArticle", "nextArticle", "previousArticle"]), {
    options: function options() {
      return {
        width: 25,
        height: 25
      };
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(["goToNextArticle", "goToPreviousArticle"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335043cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticlePage.vue
var ArticlePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"article-page"},[_c('article',{staticClass:"article-content",domProps:{"innerHTML":_vm._s(_vm.currentArticle.article)}}),_vm._v(" "),(_vm.previousArticle)?_c('div',{on:{"click":_vm.goToPreviousArticle}},[_c('feather-icon',{staticClass:"navigation-link navigation-article--prev",attrs:{"id":"article-previous","icon":"play","options":_vm.options}})],1):_vm._e(),_vm._v(" "),(_vm.nextArticle)?_c('div',{on:{"click":_vm.goToNextArticle}},[_c('feather-icon',{staticClass:"navigation-link navigation-article--next",attrs:{"id":"article-next","icon":"play","options":_vm.options}})],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"article-close","onclick":"Publish.closeArticle()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)])}
var ArticlePage_staticRenderFns = []
var ArticlePage_esExports = { render: ArticlePage_render, staticRenderFns: ArticlePage_staticRenderFns }
/* harmony default export */ var components_ArticlePage = (ArticlePage_esExports);
// CONCATENATED MODULE: ./src/components/ArticlePage.vue
function ArticlePage_injectStyle (ssrContext) {
  __webpack_require__("nPlW")
}
var ArticlePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticlePage___vue_template_functional__ = false
/* styles */
var ArticlePage___vue_styles__ = ArticlePage_injectStyle
/* scopeId */
var ArticlePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ArticlePage___vue_module_identifier__ = null
var ArticlePage_Component = ArticlePage_normalizeComponent(
  ArticlePage,
  components_ArticlePage,
  ArticlePage___vue_template_functional__,
  ArticlePage___vue_styles__,
  ArticlePage___vue_scopeId__,
  ArticlePage___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticlePage = (ArticlePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleContainer.vue

//
//
//
//
//
//
//
//
//







/* harmony default export */ var ArticleContainer = ({
  components: {
    ArticleNavigationBar: src_components_ArticleNavigationBar,
    ArticleMenu: src_components_ArticleMenu,
    ArticlePage: src_components_ArticlePage,
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["currentArticle", "nextArticle", "previousArticle"]
  // "showArticles"
  ), {
    options: function options() {
      return {
        width: 25,
        height: 25
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c35ec1fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleContainer.vue
var ArticleContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article-container"}},[_c('article-navigation-bar'),_vm._v(" "),_c('article-page'),_vm._v(" "),_c('article-menu')],1)}
var ArticleContainer_staticRenderFns = []
var ArticleContainer_esExports = { render: ArticleContainer_render, staticRenderFns: ArticleContainer_staticRenderFns }
/* harmony default export */ var components_ArticleContainer = (ArticleContainer_esExports);
// CONCATENATED MODULE: ./src/components/ArticleContainer.vue
function ArticleContainer_injectStyle (ssrContext) {
  __webpack_require__("RIzX")
}
var ArticleContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticleContainer___vue_template_functional__ = false
/* styles */
var ArticleContainer___vue_styles__ = ArticleContainer_injectStyle
/* scopeId */
var ArticleContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ArticleContainer___vue_module_identifier__ = null
var ArticleContainer_Component = ArticleContainer_normalizeComponent(
  ArticleContainer,
  components_ArticleContainer,
  ArticleContainer___vue_template_functional__,
  ArticleContainer___vue_styles__,
  ArticleContainer___vue_scopeId__,
  ArticleContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticleContainer = (ArticleContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer,
    ArticleContainer: src_components_ArticleContainer,
    ArticleNavigationBar: src_components_ArticleNavigationBar
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isArticle', 'articleFontSize'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    this.changeSize();
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      console.log('BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB');
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      console.log('DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD');
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        console.log('CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC');
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        console.log('FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF');
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });

        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    changeSize: function changeSize() {
      if (this.currentPage.pageIndex == 0) {
        this.changePageSize({
          double: true
        });
      } else {
        this.changePageSize({
          double: false
        });
      }
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize', 'changePageSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117f09c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.isArticle)?[_c('article-container')]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":page.pageIndex == 0 ? 1448 : 724,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Mix+")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_IS_FRONT_PAGE = 'UPDATE_IS_FRONT_PAGE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var OPEN_ARTICLE = 'OPEN_ARTICLE';
var CLOSE_ARTICLE = 'CLOSE_ARTICLE';

var INCREASE_ARTICLE_FONT_SIZE = 'INCREASE_ARTICLE_FONT_SIZE';
var DECREASE_ARTICLE_FONT_SIZE = 'DECREASE_ARTICLE_FONT_SIZE';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Cartier Philanthropy Rapport Annuel 2019-2020",
  "shortTitle": "",
  "description": "",
  "width": 724,
  "height": 900,
  "currentLanguage": "FR",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://reports.cartierphilanthropy.org/AR2019-20/en"
  }, {
    code: "FR",
    text: "French",
    href: "https://reports.cartierphilanthropy.org/AR2019-20/fr"
  }],
  // "basePath": "",
  "basePath": "/AR2019-20/fr",
  "companyLogo": "cp-logo.png",
  "publishURL": "https://reports.cartierphilanthropy.org/AR2019-20/fr/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/AR2019-20/fr/static/_content/Cartier-Philanthropy_Rapport-Annuel-2019-2020.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 1-title\" style=\"top:800px; left:1167px;\" src=\"/AR2019-20/fr/static/_content/1-title-1.png\">        \n      <img class=\"halfScaleC 1-logo\" style=\"top:278px;left:1033px;\" src=\"/AR2019-20/fr/static/_content/1-logo-1.png\">        \n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-logo\"), 0.6, {opacity:0, scale: 0}, {opacity:1, scale: 0.5, ease: Power2.easeOut}, 1)\n          pg1Anim.fromTo(cOf(\"1-title\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "RAPPORT ANNUEL  2019 - 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScaleC 2-pie\" style=\"top:-9px;left:236px;\" src=\"/AR2019-20/fr/static/_content/2-pie-1.png\">\n      <img class=\"halfScaleC 2-pie\" style=\"top:154px;left:-14px;\" src=\"/AR2019-20/fr/static/_content/2-pie-2.png\">\n      <img class=\"halfScaleC 2-pie\" style=\"top:221px;left:333px;\" src=\"/AR2019-20/fr/static/_content/2-pie-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim.staggerFromTo(cOf(\"2-pie\"), 1, {scale: 0}, {scale: 0.5, ease: Bounce.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n        }\n      ",
    "searchText": "Distribution  ALLOCATION  géographique  BUDGÉTAIRE  53.5% 29% 11%  Amérique Latine  3.5% 2% 1%  Par secteur 44%  Global  Europe (Covid-19) Moyen-Orient  Services de base  Services de base  23%  Modes de subsistance  22%  Développement social et économique des femmes  11%  Afrique  Asie  20%  Santé  24%  Nutrition  30%  Éducation  26%  Eau  Urgences MSF  RDC  NOUVELLE DONATION  NOUVELLE DONATION  Buildher  Muso  Kenya  Mali NOUVELLE DONATION  Room to Read  Bangladesh, Cambodge NOUVELLE DONATION  Saha Global  DONATION DE SUIVI  NOUVELLE DONATION  BRAC  BOMA Project  Ouganda  Kenya  NOUVELLE DONATION  Healthy Learners  Zambie NOUVELLE DONATION  SOIL  Haïti  Ghana  DONATION DE SUIVI  DONATION DE SUIVI  Kheyti  Root Capital  Inde  Pérou  DONATION DE SUIVI  Tostan  Sénégal, Gambie, Guinée-Bissau  Avril  Mission en Jordanie, Liban  IECD, PAM  Juillet Mission en Zambie, Kenya  Buildher, mothers2mothers, StrongMinds  Août  Octobre  Mission à Madagascar  Blue Ventures, IECD, Pivot, WSUP  2019  Novembre Mission au Bangladesh  Asian University for Women, BRAC, Room to Read, VisionSpring"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"3-no1\" class=\"abs brillcutreg 3-no\" style=\"left:77px;top:64px;font-size:4.4em;font-weight:400;margin:0;color:#808285;padding:0;margin:0;\"  data-number='{\"to\": 65, \"comma\": true}'></h1>\n        <h1 id=\"3-no2\" class=\"abs brillcutreg 3-no\" style=\"left:262px;top:148px;font-size:4.4em;font-weight:400;margin:0;color:#808285;padding:0;margin:0;\"  data-number='{\"to\": 40, \"comma\": true}'></h1>\n        <h1 id=\"3-no3\" class=\"abs brillcutreg 3-no\" style=\"left:191px;top:252px;font-size:4.4em;font-weight:400;margin:0;color:#808285;padding:0;margin:0;\"  data-number='{\"to\": 29, \"comma\": true}'></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n            pg3Anim.fromTo(cOf(\"3-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"3-no\")[0]);}}, 1)\n            .fromTo(cOf(\"3-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"3-no\")[1]);}}, \"+=0.2\")\n            .fromTo(cOf(\"3-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"3-no\")[2]);}}, \"+=0.2\")\n      }\n\n      function onPageLeave() {\n        pg3Anim.stop();\n        resetNumbers(\"3-no\");\n        removeContentLinks();\n      }\n      ",
    "searchText": "65  million de francs Suisse investis à ce jour  40 29  partenaires  pour un avenir plus fort  pays  à faible revenu  RÉPONSE À L’URGENCE MSF  MSF  Niger, RDC  Belgique, France, Espagne, Grèce, Italie, Suisse  SOS MÉDITERRANÉE  Mer Méditerranée  Visiting Nurse Service of New York, Harlem Children’s Zone, DonorsChoose  États Unis TECHO  Brésil, Colombie, Mexique  DONATIONS  DONATION DE SUIVI  One Acre Fund  Rwanda NOUVELLE DONATION  IECD  Liban  DONATION DE SUIVI  DONATION DE SUIVI  Village Enterprise  Ouganda  IECD  DONATION DE SUIVI  Madagascar  mothers2mothers  Ouganda DONATION DE SUIVI  StrongMinds  Zambie  Décembre  Janvier  Février  Mars  Mai  2020 MISSIONS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 4-block\" style=\"top:496px;left:122px;\" src=\"/AR2019-20/fr/static/_content/4-block-1.png\">\n      <img class=\"halfScale 4-block\" style=\"top:214px;left:449px;\" src=\"/AR2019-20/fr/static/_content/4-block-2.png\">\n      <img class=\"halfScale 4-block\" style=\"top:64px;left:542px;\" src=\"/AR2019-20/fr/static/_content/4-block-4.png\">\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-block\")[0], 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"4-block\")[1], 0.6, {opacity:0,x: 60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"4-block\")[2], 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 2.2)\n        }\n\n        function onPageLeave() {\n        pg4Anim.stop();\n        }\n      ",
    "searchText": "BELGIQUE ESPAGNE FRANCE GRÈCE ITALIE SUISSE I  LES PROGRAMMES QUE  NOUS SOUTENONS  Axe : Réponse à l’urgence Partenaire : MSF  MAROC  I  MALI  I  SÉNÉGAL  I  GAMBIE  I  GUINÉE-BISSAU  I  BURKINA FASO  I  Axe : Modes de subsistance Partenaire : Education for Employment  Axe : Accès aux services de base (santé) Partenaire : Muso  Axes : Accès aux services de base (santé), Développement social et économique des femmes, Modes de subsistance Partenaires : Amref, MSI, myAgro, Tostan  Axe : Développement social et économique des femmes Partenaire : Tostan  MEXIQUE  I  Axe : Développement social et économique des femmes Partenaire : CREA  GUATEMALA  I  Axe : Accès aux services de base (nutrition) Partenaire : Semilla Nueva  HAÏTI  I  PÉROU  I  Axe : Accès aux services de base (eau) Partenaire : SOIL  Axe : Développement social et économique des femmes Partenaire : Tostan  Axe : Accès aux services de base (éducation, nutrition) Partenaire : PAM  GHANA  I  Axe : Accès aux services de base (eau) Partenaire : Saha Global  TOGO  I  NIGER  I  Axe : Accès aux services de base (santé) Partenaire : Santé Intégrée  Axe : Réponse à l’urgence Partenaire : MSF  RDC I  Axe : Modes de subsistance Partenaires : Root Capital, Terre des Hommes Suisse  Axe : Réponse à l’urgence Partenaire : MSF  ZAMBIE  I  Axes : Accès aux services de base (santé), Développement social et économique des femmes Partenaires : Healthy Learners, StrongMinds"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 5-block\" style=\"top:63px; left:0px;\" src=\"/AR2019-20/fr/static/_content/5-block-2.png\">\n      <img class=\"halfScale 5-block\" style=\"top:398px; left:243px;\" src=\"/AR2019-20/fr/static/_content/5-block-3.png\">\n      <img class=\"halfScale 5-block\" style=\"top:63px; left:0px;\" src=\"/AR2019-20/fr/static/_content/5-block-4.png\">\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim.fromTo(cOf(\"5-block\")[0], 0.6, {opacity:0,x:60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"5-block\")[1], 0.6, {opacity:0,x: 60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"5-block\")[2], 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 2.2)\n        }\n\n        function onPageLeave() {\n        pg5Anim.stop();\n        }\n      ",
    "searchText": "I  KOSOVO  I  Axe : Développement social et économique des femmes Partenaire : Women for Women International  I  MER MEDITÉRRANÉE I  Axe : Réponse à l’urgence Partenaire : SOS Méditerranée  LIBAN  I  Axe : Accès aux services de base (éducation) Partenaire : IECD  JORDANIE  Axe : Accès aux services de base (éducation, nutrition) Partenaire : PAM  OUGANDA  Axes : Accès aux services de base (eau), Développement social et économique des femmes, Modes de subsistance Partenaires : BRAC, FICR, mothers2mothers, Village Enterprise I  ÉTHIOPIE  Axe : Accès aux services de base (éducation) Partenaire : Luminos Fund  I  INDE  Axes : Accès aux services de base (éducation), Développement social et économique des femmes, Modes de subsistance Partenaires : Azad Foundation, Educate Girls, Kheyti I  I  KENYA  I I  RWANDA  Axes : Développement social et économique des femmes, Modes de subsistance Partenaires : One Acre Fund, Women for Women International  TANZANIE  Axe : Développement social et économique des femmes Partenaire : Hand in Hand International I  MOZAMBIQUE  Axe : Accès aux services de base (éducation, nutrition) Partenaire : PAM  I  MADAGASCAR  Axes : Accès aux services de base (eau, éducation), Modes de subsistance Partenaires : Blue Ventures, IECD, WSUP  MYANMAR  Axes : Accès aux services de base (eau), Développement social et économique des femmes, Modes de subsistance Partenaires : FICR, Proximity Designs, SAD I  I  BANGLADESH  Axes : Accès aux services de base (éducation, santé), Réponse à l’urgence Partenaires : AUW, BRAC, Room to Read, VisionSpring  Axes : Accès aux services de base (santé), Développement social et économique des femmes Partenaires : BOMA Project, Buildher, Living Goods  CAMBODGE  Axe : Accès aux services de base (eau, éducation) Partenaires : FICR, Room to Read"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "NOTRE AMBITION EST D’AIDER À LIBÉRER LE POTENTIEL DE CHACUN"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLinkNone\" style=\"top:212px;left:319px;width:230px;height:64px;\" onclick=\"Publish.goToPage(8)\"></div>\n        <div class=\"contentLinkNone\" style=\"top:305px;left:319px;width:260px;height:64px;\" onclick=\"Publish.goToPage(9)\"></div>\n        <div class=\"contentLinkNone\" style=\"top:400px;left:319px;width:230px;height:64px;\" onclick=\"Publish.goToPage(11)\"></div>\n        <div class=\"contentLinkNone\" style=\"top:496px;left:319px;width:230px;height:76px;\" onclick=\"Publish.goToPage(21)\"></div>\n        <div class=\"contentLinkNone\" style=\"top:604px;left:319px;width:230px;height:76px;\" onclick=\"Publish.goToPage(29)\"></div>\n        <div class=\"contentLinkNone\" style=\"top:713px;left:319px;width:230px;height:76px;\" onclick=\"Publish.goToPage(39)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "SOMMAIRE  8 Message du président  9 Lettre de la directrice exécutive  11 Accès aux services de base  21  Développement social et économique des femmes  29  Modes de subsistance et écosystèmes durables  39  Réponse et préparation aux situations d’urgence"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 139px; left: 198px; width: 433px; height: 694px;\" onclick=\"Publish.openArticle(0)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n        }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLink();\n          Publish.closeArticle();\n        }\n      ",
    "searchText": "MESSAGE DU PRÉSIDENT Quelle est la place du mécénat d’entreprise dans notre société ? La question est ancienne, et ses réponses multiples. L’engagement philanthropique de Cartier envers la société s’exprime à travers Cartier Philanthropy pour donner une dimension concrète à nos valeurs : générosité, confiance, respect et compassion. La fondation illustre notre implication sans équivoque dans la construction d’un monde plus inclusif et équitable, tout comme Cartier Women’s Initiative et d’autres actions fortes de notre Maison. Tout au long de l’année, Cartier Philanthropy s’évertue à apporter des solutions aux défis les plus prégnants dans les régions les moins développées du monde, nous rappelant ainsi que nous avons tous, individus comme entreprises, le potentiel — et donc le devoir — d’agir. À travers ses initiatives, la fondation nous encourage à faire face aux menaces, même les plus redoutables, avec rigueur et détermination. Pas parce que c’est ce que l’on attend de nous. Pas pour faire la une. Mais parce que c’est notre responsabilité de citoyens du monde. À l’heure où j’écris ces lignes, l’humanité affronte la pandémie du coronavirus. Partout, des gens se battent pour endiguer la maladie, sauver des vies, et maintenir leurs moyens de subsistance. Le virus nous a rappelé que, quels que soient nos sentiments de faiblesse et de vulnérabilité face au danger, nous sommes toujours entourés de personnes plus vulnérables que nous. Notre aide leur est essentielle. Nous ne pouvions donc que nous associer à l’effort humanitaire international déployé en Europe, en Amérique du Nord et du Sud, en Chine, au Moyen-Orient et en Asie du Sud-Est. Cet impératif s’est naturellement imposé dans la logique de l’approche philanthropique de Cartier, enracinée dans la compassion, le pragmatisme et l’ouverture d’esprit. Nous n’avons pourtant pas détourné notre attention des plus vulnérables. Comme vous le lirez dans ce rapport, nous avons élargi notre champ d’action pour soutenir le travail fourni sans relâche par Médecins Sans Frontières et d’autres organisations afin de venir en aide à celles et ceux qui sont ou étaient dans le besoin en Italie, en France, en Belgique, en Espagne, en Suisse et en Grèce. Une fois encore, Cartier Philanthropy nous a permis de répondre rapidement à une crise sans précédent, unis dans un esprit de solidarité pour agir efficacement en ces temps difficiles.  Cyrille Vigneron Président du conseil de fondation, Cartier Philanthropy PDG de Cartier 8"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 119px; left: 218px; width: 433px; height: 584px;\" onclick=\"Publish.openArticle(1)\"></div>\n      ",
    "script": "\n      function onPageEnter() {\n        setTimeout(function(){\n          addContentLinks();\n      }, 1000)\n      }\n\n      function onPageLeave() {\n        removeContentLink();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "LETTRE DE LA DIRECTRICE EXÉCUTIVE Pendant des mois, le monde entier a retenu son souffle alors que le coronavirus se propageait, évoluait et que nous apprenions à y faire face. Il serait impossible d’éluder dans cette lettre une des pires crises sanitaires que le monde ait jamais connues, une pandémie dont la portée internationale a peu d’équivalents dans l’Histoire de l’humanité. Cependant, il serait profondément injuste de réduire douze mois de travail passionné à cette urgence, aussi inédite soit-elle. On entend souvent dire que la crise du coronavirus a tout changé, mais, dans certains cas, elle n’a fait qu’accentuer des tendances et des faiblesses existantes, tout en braquant les projecteurs sur les défaillances majeures de notre société. Nombre de ces défis sont ceux auxquels Cartier Philanthropy s’engage à répondre dans le cadre de sa mission en finançant des organisations partenaires extrêmement efficaces dont les actions améliorent concrètement les vies des plus vulnérables. L’identification et le financement d’organisations audacieuses et novatrices avec lesquelles établir des alliances à long terme est au cœur de notre action afin d’assurer un impact social maximal. Nous sommes convaincus qu’il est de notre devoir de les servir au mieux afin qu’elles puissent mettre leurs solutions à la disposition du plus grand nombre. Ces organisations ont besoin non seulement que nous fassions preuve de flexibilité et de pragmatisme, mais aussi que nous prêtions une oreille attentive à leurs besoins et leurs difficultés. En d’autres termes, nous travaillons pour elles, pas l’inverse. Notre manière de procéder n’a pas changé quand le coronavirus a frappé et elle ne changera pas une fois que la crise sera terminée. C’est ce que reflètent les divers partenariats que nous avons renouvelés cette année (8) ainsi que les profils des sept organisations qui ont rejoint notre portfolio. Je vous invite à découvrir leur travail remarquable dans le rapport de cette année.  Pascale de la Frégonnière Directrice exécutive  9"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 11-title\" style=\"top:244px; left:186px;\" src=\"/AR2019-20/fr/static/_content/11-title-1.png\"> \n      <img class=\"halfScale 11-sub\" style=\"top:304px; left:359px;\" src=\"/AR2019-20/fr/static/_content/11-sub-1.png\"> \n      <div class=\"abs pointer\" style=\"top: 297px; left: 348px; width: 313px; height: 261px; \" onclick=\"Publish.openArticle(2)\"></div>\n      <div class=\"abs pointer\" style=\"top: 239px; left: 178px; width: 506px; height: 39px;\" onclick=\"Publish.openArticle(2)\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.fromTo(cOf(\"11-title\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"11-sub\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          removeContentLink()\n          Publish.closeArticle();\n        }\n      ",
    "searchText": "ACCÈS AUX SERVICES DE BASE Chaque jour, même en ces temps incertains et difficiles, des organisations s’engagent pour améliorer l’accès à une éducation de qualité, aux soins de santé primaires, à l’eau potable, à une bonne hygiène et à une alimentation équilibrée. Cependant, le rythme de ces améliorations doit s’accélérer si nous voulons faire en sorte que chaque personne puisse mener une existence saine et épanouissante.  11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"12-no1\" class=\"abs brillcutmed 12-no\" style=\"left: 516px; top: 503px; font-size: 2.2em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 38, \"append\": \"%\"}'></h1>\n\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 581px; height: 46px;\" onclick=\"Publish.openArticle(3)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 499px; left: 81px; width: 336px; height: 316px;\" onclick=\"Publish.openArticle(3)\"></div>\n\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(cOf(\"12-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no\")[0]);}}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          resetNumbers(\"12-no\");\n          removeContentLinks();\n          Publish.closeArticle();\n        }\n      ",
    "searchText": "NOUVEAUX  PROGRAMMES Partenaire : Healthy Learners Pays : Zambie Durée : 2019-2022  Veiller sur la santé des élèves pour leur permettre d’apprendre En Zambie, près de 40 % des enfants en âge d’être scolarisés manquent régulièrement les cours à cause de maladies que l’on peut soigner et éviter, qui affectent leur développement et peuvent entrainer le décrochage scolaire. Healthy Learners aide les écoles à devenir des points d’accès aux soins pour les enfants. Certains professeurs reçoivent une formation d’agent de santé et sont ainsi en mesure de surveiller la santé des élèves, d’évaluer l’état des enfants souffrants, de prodiguer des soins de base et d’envoyer les enfants malades au centre de santé, ainsi que les jeunes filles nécessitant un suivi en santé sexuelle et reproductive.  Nous soutenons les efforts de Healthy Learners pour assurer un accès aux soins à 285 000 enfants fréquentant les écoles primaires publiques des provinces de Lusaka et de Copperbelt d’ici 2022.  12  38%  de réduction de la morbidité"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"13-no1\" class=\"abs brillcutreg 13-no\" style=\"left: 518px; top: 392px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 98, \"append\": \"%\"}'></h1>\n        <h1 id=\"13-no1\" class=\"abs brillcutreg 13-no\" style=\"left: 459px; top: 451px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 77, \"append\": \"%\"}'></h1>\n        <h1 id=\"13-no1\" class=\"abs brillcutreg 13-no\" style=\"left: 123px; top: 740px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 1270, \"comma\": \"true\"}'></h1>\n      \n      <div class=\"contentLinkNone abs\" style=\"top: 99px; left: 64px; width: 366px; height: 351px;\" onclick=\"Publish.openArticle(3)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 537px; left: 341px; width: 296px; height: 296px;\" onclick=\"Publish.openArticle(3)\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(cOf(\"13-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[0]);}}, 1)\n          .fromTo(cOf(\"13-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[1]);}}, \"+=0.2\")\n          .fromTo(cOf(\"13-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[2]);}}, \"+=0.2\")\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n          resetNumbers(\"13-no\");\n          removeContentLinks();\n          Publish.closeArticle();\n        }\n      ",
    "searchText": "Priorité à l’éducation secondaire des filles Au Bangladesh et au Cambodge, les préjugés culturels, les discriminations de genre, l’insécurité, le besoin de contribuer aux revenus familiaux et l’injonction à se marier et à créer une famille entravent fortement la réussite scolaire des filles, en particulier dans le secondaire. Le programme d’éducation pour les filles de Room to Read permet aux élèves de poursuivre leur scolarité plus longtemps et d’acquérir au terme de leurs études secondaires les connaissances, les aptitudes et les capacités qui leur permettront de réussir à l’école et dans la vie. Encadré par des femmes de leurs communautés, le programme propose des séances sur les aptitudes à la vie quotidienne, du mentorat individuel et en groupe, un système de soutien social et une prise en charge qui, selon les besoins, inclut les frais scolaires et de transport, les uniformes et la préparation aux examens. Nous soutenons Room to Read afin d’offrir à 4 350 jeunes bangladeshies et cambodgiennes la possibilité de terminer leurs études secondaires et réaliser leur potentiel.  Partenaire : Room to Read Pays : Bangladesh, Cambodge Durée : 2019-2022  98%  En 2018, des élèves qui ont bénéficié du programme au Bangladesh et  77%  des élèves cambodgiennes ont poursuivi des études supérieures.  Lutter contre la malnutrition au Guatemala  Partenaire : Semilla Nueva Pays : Guatemala Durée : 2019-2021  1 270  Plus de sacs de semences ont été vendus en 2018, ce qui signifie que plus de 70 800 personnes ont consommé du maïs enrichi en nutriments pendant un an.  Au Guatemala, les tortillas de maïs sont au menu de chaque repas. Malheureusement, elles sont pauvres en nutriments. Semilla Nueva produit et commercialise des semences de maïs bio-fortifiées, enrichies de manière traditionnelle en protéines de qualité et zinc. Les cultures bio-fortifiées constituent une solution efficace et culturellement adaptée contre la malnutrition chronique au Guatemala puisqu’elles n’altèrent pas le régime alimentaire traditionnel.  À la suite d’une première subvention de trois ans, nous renouvelons notre soutien à Semilla Nueva afin de généraliser la consommation de maïs bio-fortifié et de fournir à 255 000 personnes du maïs plus riche en nutriments. 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 586px; height: 46px;\" onclick=\"Publish.openArticle(3)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 530px; left: 291px; width: 366px; height: 306px;\" onclick=\"Publish.openArticle(3)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 152px; left: 321px; width: 336px; height: 350px;\" onclick=\"Publish.openArticle(3)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          Publish.closeArticle();\n        }\n      ",
    "searchText": "NOUVEAUX  PROGRAMMES  Un centre pour les enfants syriens réfugiés au Liban  Partenaire : IECD Pays : Liban Durée : 2019-2023  Le conflit syrien, qui a entraîné des déplacements massifs de population, fait peser une pression considérable sur les pays d’accueil et plus particulièrement sur leurs systèmes éducatifs. Au Liban, malgré les efforts consentis par le ministère de l’Éducation, qui autorise l’inscription gratuite dans les écoles publiques sans exiger de permis de résidence, plus de 300 000 enfants syriens réfugiés restent non scolarisés. Le Centre Janah à Beyrouth accueille les enfants et adolescents issus de familles défavorisées tant syriennes que libanaises. En proposant un soutien scolaire, des activités extrascolaires et un soutien psychosocial, le centre aide les enfants à réintégrer l’école et à réussir leur scolarité.  Notre contribution permettra à 535 enfants et jeunes pendant trois ans de recevoir un soutien scolaire, participer à des activités de développement personnel et bénéficier également d’un transport gratuit et d’un goûter quotidien.  L’eau propre : une affaire de femme Dans le nord du Ghana les populations n’ont pas accès à l’eau Partenaire : Saha Global Pays : Ghana potable. Les villages dépendent du Durée : 2019-2022 ruissellement de l’eau de pluie qui s’accumule dans de grands étangs stagnants. Mais cette eau, boueuse et insalubre, représente un risque important pour leur santé. Saha Global s’efforce d’introduire une technologie de traitement de l’eau simple et abordable dans les communautés les plus pauvres et reculées du pays. Son objectif est de former les femmes dans les villages pour qu’elles puissent établir et maintenir des petites entreprises de traitement de l’eau afin d’approvisionner leurs communautés en eau potable au coût abordable et ainsi générer des revenus. Nous soutenons Saha Global pour mettre en place près de 1 000 nouvelles microentreprises de traitement de l’eau destinées à desservir environ 440 000 personnes d’ici à la fin 2022. 14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"15-no1\" class=\"abs brillcutreg 15-no\" style=\"left: 70px; top: 374px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 93, \"append\": \"%\"}'></h1>\n\n        <div class=\"contentLinkNone abs\" style=\"top: 251px; left: 231px; width: 406px; height: 296px;\" onclick=\"Publish.openArticle(3)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 605px; left: 231px; width: 406px; height: 230px;\" onclick=\"Publish.openArticle(3)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(cOf(\"15-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[0]);}}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          resetNumbers(\"15-no\");\n          removeContentLinks();\n          Publish.closeArticle();\n        }\n      ",
    "searchText": "Partenaire : Muso Pays : Mali Durée : 2019-2022  La santé n’attend pas Dans les communautés de la périphérie de Bamako, la mortalité des enfants a été réduite de  93% en  trois ans !  Le Mali présente un des plus haut taux de mortalité des enfants de moins de 5 ans dans le monde. Depuis 2008, Muso collabore avec le gouvernement pour transformer la manière dont les soins de santé sont dispensés afin de pouvoir traiter les malades quelques heures après l’apparition des premiers symptômes. Ce «modèle de soins de santé proactifs » consiste à former des agents de santé communautaire qui se rendent dans les villages pour repérer et soigner gratuitement les personnes malades à domicile, ou les mettre en contact avec des cliniques publiques compétentes. Dans les communautés où ce système a été mis en œuvre, la mortalité des enfants a chuté massivement.  Notre soutien va permettre la constitution d’une équipe technique dédiée auprès de gouvernements, décideurs politiques et personnel de santé au Mali et hors de ses frontières pour assurer l’adoption des soins de santé proactifs. Muso envisage de servir 450 000 patients directement et 18 millions de patients indirectement au cours des trois prochaines années.  Partenaire : SOIL Pays : Haïti Durée : 2019-2022  Des toilettes écologiques pour une santé durable  En Haïti, 66 % des habitants des zones urbaines n’ont pas accès à des installations sanitaires et moins de 1 % des excréments sont traités en toute sécurité. Le manque de toilettes a engendré une crise sanitaire publique majeure : Haïti a le taux de diarrhée infantile le plus élevé au monde. Depuis 2006, SOIL travaille dans le pays pour y promouvoir la santé et des moyens de subsistance durables. Grâce à ses installations sanitaires sûres, l’organisation collecte et transforme les excréments en compost à haute valeur agricole. Nous soutenons SOIL avec l’objectif de fournir à 12 000 Haïtiens des installations sanitaires à faible coût qui associent des toilettes sèches à des services de traitement et de transformation des déchets. 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"16-no1\" class=\"abs brillcutreg 16-no\" style=\"left: 88px; top: 523px; font-size: 1.53em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 65700, \"comma\": \"true\", \"append\": \" personnes\"}'></h1>\n        <h1 id=\"16-no1\" class=\"abs brillcutreg 16-no\" style=\"left: 143px; top: 730px; font-size: 1.53em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 9200, \"comma\": \"true\", \"append\": \" personnes\"}'></h1>\n        <h1 id=\"16-no1\" class=\"abs brillcutmed 16-no\" style=\"left: 459px; top: 683px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 51, \"append\": \"%\"}'></h1>\n        <h1 id=\"16-no1\" class=\"abs brillcutmed 16-no\" style=\"left: 453px; top: 738px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 89, \"append\": \"%\"}'></h1>\n\n        <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 84px; width: 278px; height: 746px;\" onclick=\"Publish.openArticle(4)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[0]);}}, 1)\n          .fromTo(cOf(\"16-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[1]);}}, \"+=0.2\")\n          .fromTo(cOf(\"16-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[2]);}}, \"+=0.2\")\n          .fromTo(cOf(\"16-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[3]);}}, \"+=0.2\")\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          removeContentLinks();\n          Publish.closeArticle();\n        }\n      ",
    "searchText": "RÉSULTATS Prévenir le choléra dans les communautés de pêcheurs de l’Ouganda Le choléra est endémique sur les rives du lac Albert. La pêche constitue la principale activité économique de la région et l’accès à l’eau et à l’assainissement est extrêmement limité. Nous avons soutenu la Croix-Rouge pour améliorer durablement les conditions de vie et l’état de santé de 10 000 habitants du rift Albertin, au nord-ouest de l’Ouganda, en portant une attention particulière à l’adoption de bonnes pratiques d’hygiène, à l’approvisionnement en eau potable et à l’installation de sanitaires adéquats. Des agents de santé bénévoles de la Croix-Rouge ont sensibilisé à l’hygiène plus de  65 700 personnes,  entraînant une hausse de 38 % de la construction et de l’utilisation de latrines privées, de sanitaires, de séchoirs, de points de lavage des mains et de fosses à déchets.  Partenaire : FICR Pays : Ouganda Durée : 2017-2019  La couverture en installations sanitaires des centres de santé et des écoles de la région a été fortement améliorée.  De  51%  9 200 personnes  Plus de ont pu accéder à de l’eau potable grâce à la construction et réhabilitation de 8 puits et l’ajout de 6 kilomètres de conduites au système d’alimentation en eau. 16  à  89%"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"17-no1\" class=\"abs brillcutreg 17-no\" style=\"left: 70px; top: 298px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 160, \"comma\": \"true\"}'></h1>\n        <h1 id=\"17-no1\" class=\"abs brillcutreg 17-no\" style=\"left: 70px; top: 407px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 1558, \"comma\": \"true\"}'></h1>\n        <h1 id=\"17-no1\" class=\"abs brillcutreg 17-no\" style=\"left: 346px; top: 361px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 37500, \"comma\": \"true\"}'></h1>\n        <h1 id=\"17-no1\" class=\"abs brillcutreg 17-no\" style=\"left: 70px; top: 758px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;\"  data-number='{\"to\": 80, \"comma\": \"true\", \"append\": \"%\"}'></h1>\n        <div class=\"contentLinkNone abs\" style=\"top: 102px; left: 344px; width: 298px; height: 352px;\" onclick=\"Publish.openArticle(4)\"></div>\n        <div class=\"contentLinkNone abs\" style=\"top: 300px; left: 64px; width: 258px; height: 201px;\" onclick=\"Publish.openArticle(4)\"></div>\n        <div class=\"contentLinkNone abs\" style=\"top: 510px; left: 64px; width: 480px; height: 181px;\" onclick=\"Publish.openArticle(4)\"></div>\n        <div class=\"contentLinkNone abs\" style=\"top: 636px; left: 544px; width: 58px; height: 55px;\" onclick=\"Publish.openArticle(4)\"></div>\n        <div class=\"contentLinkNone abs\" style=\"top: 691px; left: 64px; width: 228px; height: 29px;\" onclick=\"Publish.openArticle(4)\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim.fromTo(cOf(\"17-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[0]);}}, 1)\n          .fromTo(cOf(\"17-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[1]);}}, \"+=0.2\")\n          .fromTo(cOf(\"17-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[2]);}}, \"+=0.2\")\n          .fromTo(cOf(\"17-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[3]);}}, \"+=0.2\")\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n          removeContentLinks();\n          Publish.closeArticle();\n\n        }\n      ",
    "searchText": "Surmonter les distances pour améliorer la santé des enfants  160  missions de dépistage ont été organisées dans les écoles et les centres de santé pour la détection précoce et le traitement des maladies infantiles les plus communes  1 558  enfants ont reçu un suivi médical gratuit et de qualité dans le cadre de 9 camps de chirurgie et 12 mini-camps de consultations spécialisées.  Au Sénégal, la concentration des médecins généralistes Partenaire : Amref Pays : Sénégal et des spécialistes dans Durée : 2016-2019 les hôpitaux de la capitale entraîne une grande disparité entre les services médicaux et chirurgicaux disponibles à Dakar et dans les zones reculées du Sud. En cinq ans, l’Amref est parvenu à renforcer l’accès aux soins préventifs essentiels ainsi qu’aux soins spécialisés pour plus de 35 000 enfants dans 60 écoles primaires et plus de 50 postes de santé de Kolda et de Sédhiou.  37 500  femmes en âge de procréer ont renforcé leurs connaissances et leurs compétences en matière de santé reproductive, santé des enfants, hygiène et nutrition.  Nous poursuivons notre  Réduire l’abandon scolaire à Madagascar  soutien  Le niveau d’instruction à Madagascar compte parmi les pour trois ans plus bas du monde ; les enfants y sont scolarisés en moyenne pendant quatre ans seulement. Dans les communautés rurales, tout juste 19 % des enfants poursuivent des études secondaires et ils ne sont que 1 % à obtenir leur baccalauréat. Depuis 2006, l’IECD et l’association malgache PROMES collaborent pour réduire le décrochage scolaire dans les communautés rurales en créant des centres de soutien qui proposent un accompagnement individuel scolaire et extrascolaire des élèves. Nous avons financé trois centres dans la région de Fianarantsoa pour soutenir 360 élèves pendant trois ans. Partenaire : IECD Pays : Madagascar Durée : 2017-2019  80%  ont réussi l’examen du BEPC alors que le taux de réussite moyen national s’élève à 53 %. 17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 256px; left: 86px; width: 573px; height: 161px;\" onclick=\"Publish.openArticle(5)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 516px; left: 86px; width: 573px; height: 146px;\" onclick=\"Publish.openArticle(5)\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n        removeContentLinks();\n        Publish.closeArticle();\n        }\n      ",
    "searchText": "LIVING GOODS Kenya – 2018-2020 270 agents de santé communautaire prodiguent des soins de qualité à domicile à plus de 220 000 personnes à l’ouest du Kenya.  WATER AND SANITATION FOR THE URBAN POOR Madagascar – 2017-2020 WSUP collabore avec la compagnie nationale des eaux et les communautés locales pour concevoir des services d’approvisionnement en eau et d’assainissement desservant plus de 60 000 habitants des bidonvilles urbains de Tananarive.  PROGRAMMES EN PROGRAMME ALIMENTAIRE MONDIAL  FICR Myanmar, Cambodge – 2017-2020 La Croix-Rouge collabore avec des communautés locales pour assurer à 36 000 personnes l’accès à l’eau potable, et à 39 000 l’accès à des installations sanitaires adaptées et à de bonnes pratiques d’hygiène.  COURS  Mozambique – 2017-2020  PROGRAMME ALIMENTAIRE MONDIAL  2 000 petits agriculteurs produisant du maïs, des haricots et des légumes frais pour les repas scolaires découvrent des solutions simples et abordables qui leur permettent de réduire leurs pertes post-récolte et d’augmenter leurs revenus.  Burkina Faso – 2014-2020  PROGRAMME ALIMENTAIRE MONDIAL  Une chaîne d’approvisionnement en produits laitiers dirigée par des femmes relie les petits éleveurs et les producteurs locaux à 71 cantines scolaires où 12 500 élèves reçoivent du yaourt frais pour leur collation du matin.  6 000 enfants reçoivent chaque jour des repas scolaires grâce à l’initiative «Healthy Kitchen» qui fournit un emploi à 30 réfugiés syriens et jordaniens en situation précaire.  18  Jordanie – 2018-2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 133px; left: 86px; width: 203px; height: 684px;\" onclick=\"Publish.openArticle(5)\"></div>\n      ",
    "script": "\n      function onPageEnter() {\n        setTimeout(function(){\n          addContentLinks();\n        }, 1000);\n      }\n\n      function onPageLeave() {\n      removeContentLinks();\n      Publish.closeArticle();\n\n      }\n      ",
    "searchText": "EDUCATE GIRLS Inde – 2014-2020 Educate Girls stimule la scolarisation des filles, promeut des infrastructures éducatives adaptées et améliore les résultats scolaires de 100 000 enfants dans 1 053 villages du district de Rajsamand.  SANTÉ INTÉGRÉE Togo – 2019-2021 Santé Intégrée a créé un modèle communautaire abordable permettant d’assurer à 240 000 togolais l’accès aux soins de santé primaires de qualité.  VISIONSPRING Bangladesh – 2018-2021 VisionSpring s’est associé à BRAC au Bangladesh pour fournir des lunettes résistantes, esthétiques et abordables à plus de 600 000 personnes à faible revenu.  LUMINOS FUND Éthiopie – 2018-2021 10 000 enfants éthiopiens vivant dans les régions reculées d’Afar et d’Oromiya réintégreront l’enseignement public au terme d’un programme d’apprentissage intensif de 10 mois.  19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 21-title\" style=\"top:244px; left:146px;\" src=\"/AR2019-20/fr/static/_content/21-title-1.png\">\n      <img class=\"halfScale 21-sub\" style=\"top:374px; left:367px;\" src=\"/AR2019-20/fr/static/_content/21-sub-1.png\">\n      <div class=\"pointer abs\" style=\"top: 239px; left: 138px; width: 546px; height: 37px;\" onclick=\"Publish.openArticle(6)\"></div>\n      <div class=\"pointer abs\" style=\"top: 277px; left: 358px; width: 279px; height: 67px;\" onclick=\"Publish.openArticle(6)\"></div>\n      <div class=\"pointer abs\" style=\"top: 371px; left: 358px; width: 291px; height: 402px;\" onclick=\"Publish.openArticle(6)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(cOf(\"21-title\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          pg21Anim.fromTo(cOf(\"21-sub\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n        removeContentLinks();\n        Publish.closeArticle();\n\n        }\n      ",
    "searchText": "DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES Les inégalités de genre ne sont pas seulement le produit de normes sociales discriminatoires, de déséquilibres de pouvoir et d’obstacles juridiques. Elles racontent aussi — et surtout — l’histoire des partis pris et des préjugés à l’encontre des femmes, portés par les hommes comme par les femmes, une histoire qui se répète encore et encore. Pour démanteler les inégalités structurelles, nous devons agir à plusieurs niveaux et dans divers contextes — dans les foyers, les écoles, sur les lieux de travail et dans la fonction publique — en soutenant les femmes et les filles dans leur lutte pour l’obtention de places qui leur reviennent de plein droit."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"22-no1\" class=\"abs brillcutreg 22-no\" style=\"left: 511px; top: 326px; font-size: 1.56em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;\"  data-number='{\"to\": 1400, \"append\":\"%\", \"preppend\":\"+ \", \"comma\": \"true\"}'></h1>\n      <h1 id=\"22-no1\" class=\"abs brillcutreg 22-no\" style=\"left: 511px; top: 375px; font-size: 1.56em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;\"  data-number='{\"to\": 258, \"append\":\"%\", \"preppend\":\"+ \", \"comma\": \"true\"}'></h1>\n      <h1 id=\"22-no1\" class=\"abs brillcutreg 22-no\" style=\"left: 510px; top: 442px; font-size: 1.56em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;\"  data-number='{\"to\": 147, \"append\":\"%\", \"preppend\":\"+ \", \"comma\": \"true\"}'></h1>\n\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 577px; height: 46px;\" onclick=\"Publish.openArticle(7)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 152px; left: 81px; width: 402px; height: 354px;\" onclick=\"Publish.openArticle(7)\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(cOf(\"22-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[0]);}}, 1)\n          .fromTo(cOf(\"22-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[1]);}}, \"+=0.2\")\n          .fromTo(cOf(\"22-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[2]);}}, \"+=0.2\")\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n          resetNumbers(\"22-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n\n        }\n      ",
    "searchText": "NOUVEAUX Partenaire : BOMA Project Pays : Kenya Durée : 2019-2021  PROGRAMMES  Combattre la pauvreté dans les zones arides d’Afrique  Dans les régions arides et semi-arides du nord du Kenya, des familles d’éleveurs vivent sans eau courante ni électricité, à des kilomètres des commerces, des routes asphaltées, des transports publics, des écoles et des centres de santé les plus proches. Le bétail constitue leur source principale de revenus. Des mois durant, les hommes voyagent loin avec leurs troupeaux à la recherche d’eau et de pâturage, deux ressources rares. Les femmes restent au village, prisonnières d’une pauvreté extrême et d’une insécurité alimentaire chronique. Avec des interventions séquencées qui incluent des formations pour développer des compétences et des connaissances, BOMA Project permet aux femmes les plus pauvres de créer des entreprises et des groupes d’épargne, de renforcer la sécurité financière et alimentaire de leur foyer, d’investir dans la santé et l’éducation de leurs enfants, et d’imposer un peu plus leur voix. Nous soutenons BOMA Project pour permettre à 500 000 femmes et enfants d’améliorer leurs conditions de vie.  22  L’impact de BOMA Project est décisif :  + 1 400%  d’économies  + 258% de  dépenses médicales annuelles  + 147%  de revenus des ménages"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"23-no1\" class=\"abs brillcutmed 23-no\" style=\"left: 548px; top: 426px; font-size: 2.1em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;\"  data-number='{\"to\": 8830, \"comma\": \"true\"}'></h1>\n\n      <div class=\"contentLinkNone abs\" style=\"top: 102px; left: 351px; width: 286px; height: 280px;\" onclick=\"Publish.openArticle(7)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 376px; left: 351px; width: 171px; height: 103px;\" onclick=\"Publish.openArticle(7)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 492px; left: 61px; width: 332px; height: 346px;\" onclick=\"Publish.openArticle(7)\"></div>\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg23Anim = new TimelineMax();\n        pg23Anim.fromTo(cOf(\"23-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[0]);}}, 1)\n        setTimeout(function(){\n          addContentLinks();\n        }, 1000);\n      }\n\n      function onPageLeave() {\n        pg23Anim.stop();\n        resetNumbers(\"23-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "Provoquer le changement social en Afrique de l’Ouest Le modèle collaboratif de Tostan favorise le changement social et l’évolution des comportements en engageant un dialogue intra et intercommunautaire approfondi pour sensibiliser jeunes, femmes, hommes, anciens et chefs religieux aux droits humains, à la santé, à l’hygiène, à la résolution de conflit, à l’autonomie économique et au rôle de parent. Ce travail a abouti à l’un des résultats les plus notoires à ce jour : des milliers de communautés ont déclaré publiquement avoir abandonné le mariage précoce et la pratique de l’excision. Partenaire : Tostan Pays : Gambie, Guinée-Bissau, Sénégal Durée : 2019-2023  Après avoir soutenu Tostan dans le sud-est du Sénégal de 2016 à 2018, nous contribuons à une initiative conjointe dans trois pays pour toucher plus de 107 500 personnes au sein de 1 300 communautés reculées en Gambie, en Guinée-Bissau et au Sénégal. communautés !  8 830  Place aux femmes dans le secteur de la construction En Afrique de l’Est, le secteur de la construction connaît une très forte croissance, mais est aussi l’un des plus affectés par le manque de main-d’œuvre qualifiée. Le programme pilote de Buildher forme des jeunes femmes défavorisées des bidonvilles de Nairobi, en les aidant à acquérir des compétences très recherchées dans ce domaine, ainsi qu’à obtenir un certificat professionnel reconnu qui leur donnera de meilleures chances de trouver un emploi stable et d’être économiquement indépendantes. En permettant à des femmes qualifiées d’intégrer le secteur de la construction, dominé par les hommes, Buildher contribue à bousculer les attitudes culturelles autour du caractère « genré » de certains secteurs d’emploi au Kenya. Partenaire : Buildher Pays : Kenya Durée : 2019-2021  Nous soutenons Buildher pour former 400 jeunes femmes, dont au moins 320 accèderont à un emploi rémunéré. 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"24-no1\" class=\"abs brillcutmed 24-no\" style=\"left: 559px; top: 532px; font-size: 2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 40, \"append\": \"% \xE0\"}'></h1>\n      <h1 id=\"24-no1\" class=\"abs brillcutmed 24-no\" style=\"left: 567px; top: 563px; font-size: 2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 1.3, \"decimals\": 1, \"append\": \"%!\"}'></h1>\n\n      <img class=\"halfScale 24-text\" style=\"top:510px; left:89px;\" src=\"/AR2019-20/fr/static/_content/24-text-2.png\">        \n      <img class=\"halfScale 24-text\" style=\"top:707px; left:312px;\" src=\"/AR2019-20/fr/static/_content/24-text-3.png\">        \n\n\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 366px; height: 46px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 136px; left: 302px; width: 236px; height: 46px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 199px; left: 311px; width: 336px; height: 251px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 451px; left: 311px; width: 220px; height: 47px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 505px; left: 84px; width: 444px; height: 117px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 622px; left: 84px; width: 554px; height: 77px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 701px; left: 309px; width: 367px; height: 137px;\" onclick=\"Publish.openArticle(8)\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.staggerFromTo(cOf(\"24-text\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n          .fromTo(cOf(\"24-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[0]);}}, \"+=0.3\")\n          .fromTo(cOf(\"24-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[1]);}}, \"+=0.2\")\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          resetNumbers(\"24-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "RÉSULTATS ET SUIVI Partenaire : mothers2mothers Pays : Ouganda Durée : 2017-2019 > 2020-2023  Généraliser le modèle des Mères Mentors en Ouganda mothers2mothers forme et emploie des mères séropositives en tant qu’agents de santé de première ligne. Ces Mères Mentors interviennent dans les communautés les plus défavorisées. Elles travaillent à la fois dans des centres de santé et au sein de leurs communautés pour prodiguer des soins aux femmes, aux enfants, aux adolescents et aux familles toutes entières. Elles facilitent l’accès aux soins, améliorent le maintien des patients dans le système de santé et assurent l’adhérence au traitement en concentrant leurs efforts sur la réduction des infections au VIH et aux maladies associées. Des éducatrices adolescentes travaillent aussi dans les mêmes communautés que les Mères Mentors pour sensibiliser en particulier les adolescentes et les jeunes femmes aux services de santé sexuelle Le taux de et reproductive. transmission Entre 2017 et 2019, nous avons soutenu mothers2mothers pour développer son modèle de Mères Mentors dans sept centres de santé et dans les communautés environnantes du centre-est de l’Ouganda.  82 Mères Mentors et 36 éducatrices adolescentes sont intervenues auprès de 77 000 femmes et adolescentes, principalement des femmes enceintes ou allaitantes.  du VIH de la mère à son bébé diminue de  40% à 1,3%!  Les Mères Mentors ont saisi toutes les opportunités au sein de leurs communautés pour sensibiliser les familles, les informer et les encourager à faire un test de dépistage du VIH. Grâce à leur implication, 2 771 100 267 personnes.  2020-2023 Pour atteindre 167 000 personnes dès la première année!  sessions de sensibilisation ont permis d’informer Afin d’accroitre les progrès réalisés grâce à notre premier financement, nous renouvelons notre soutien pour renforcer l’impact du modèle de Mères Mentors dans le centre-est de l’Ouganda. mothers2mothers pourra ainsi diversifier les soins proposés et agir dans les domaines de la santé maternelle et infantile, de l’apprentissage précoce, du handicap, ou encore de la santé reproductive des adolescentes. 24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"25-no1\" class=\"abs brillcutmed 25-no\" style=\"left: 485px; top: 713px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 76.5, \"append\": \"%\", \"decimals\": 1}'></h1>\n      <img class=\"halfScale 25-text\" style=\"top:541px; left:70px;\" src=\"/AR2019-20/fr/static/_content/25-text-2.png\">        \n      <img class=\"halfScale 25-text\" style=\"top:707px; left:71px;\" src=\"/AR2019-20/fr/static/_content/25-text-3.png\">        \n      <div class=\"contentLinkNone abs\" style=\"top: 205px; left: 66px; width: 336px; height: 315px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 532px; left: 66px; width: 606px; height: 112px;\" onclick=\"Publish.openArticle(8)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 701px; left: 64px; width: 334px; height: 137px;\" onclick=\"Publish.openArticle(8)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim.staggerFromTo(cOf(\"25-text\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n          .fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0]);}}, \"+=0.3\")\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n          resetNumbers(\"25-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n\n      }\n      ",
    "searchText": "Partenaire : StrongMinds Pays : Zambie Durée : 2018-2019 > 2020-2023  Soigner les femmes souffrant de dépression en Zambie La dépression est l’une des maladies les plus négligées dans les pays en voie de développement. En raison du manque d’attention prêtée aux troubles mentaux et des préjugés tenaces qui y sont attachés, rares sont celles et ceux qui peuvent reconnaître leurs symptômes et bénéficier d’une prise en charge. En outre, les services de santé mentale font cruellement défaut dans ces régions. En Ouganda, StrongMinds forme des animateurs en santé mentale chargés d’encadrer des groupes de parole : un modèle unique, simple et éprouvé pour soigner les femmes souffrant de dépression au sein de communautés défavorisées. Au terme de leur thérapie de groupe, 80 % des femmes ne souffrent plus de dépression. Entre 2018 et 2019, nous avons soutenu StrongMinds afin de constituer une équipe pour répliquer le modèle de l’Ouganda en Zambie. Les résultats sont très encourageants :  1 460 femmes vivant à Misisi, un des plus grands bidonvilles de Zambie, ont suivi la thérapie avec succès, ce qui représente 20 % de plus que l’objectif initial. Avec le soutien des nouveaux animateurs en santé mentale, ces femmes ont appris à reconnaître les déclencheurs et les symptômes de la dépression. Une fois les symptômes dépressifs neutralisés, les participantes se nourrissent mieux, présentent une meilleure forme physique et prennent mieux soin de leurs enfants.  2020-2023 StrongMinds est aujourd’hui en passe de devenir conseiller technique en santé mentale auprès du ministère zambien de la Santé. Au cours des trois prochaines années, StrongMinds compte développer son modèle à travers des partenariats et l’intégrer progressivement au système national de santé. L’objectif est de soigner plus de 8 000 femmes. 25  Au terme de la thérapie,  76,5% sont parvenues à vaincre la dépression"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"26-no1\" class=\"abs brillcutmed 26-no\" style=\"left: 539px; top: 367px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 200, \"append\": \"\"}'></h1>\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 306px; height: 46px;\" onclick=\"Publish.openArticle(9)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 154px; left: 82px; width: 378px; height: 334px;\" onclick=\"Publish.openArticle(9)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 610px; left: 334px; width: 324px; height: 227px;\" onclick=\"Publish.openArticle(9)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 699px; left: 79px; width: 264px; height: 137px;\" onclick=\"Publish.openArticle(9)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(cOf(\"26-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"26-no\")[0]);}}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          resetNumbers(\"26-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n\n      }\n      ",
    "searchText": "RÉSULTATS Des taxis conduits par des femmes pour les femmes Azad Foundation s’attaque aux barrières culturelles et socioéconomiques en Inde afin d’ouvrir aux femmes marginalisées l’accès à des métiers non traditionnels. Son programme « Women on Wheels » s’adresse aux femmes vulnérables issues de milieux défavorisés en leur offrant une formation de chauffeur professionnel. En plus de l’apprentissage essentiel de la conduite, cette formation couvre des domaines tels que les droits, l’autodéfense, l’anglais, la présentation personnelle, l’hygiène et l’éducation financière. Entre 2017 et 2020 nous avons soutenu Azad pour identifier et former des femmes vulnérables issues des quartiers les plus pauvres de Jaipur. Diverses activités ont eu lieu au sein de 225 bidonvilles pour sensibiliser les communautés aux questions d’égalité de genre. 11 346 femmes ont été exposées à ces sessions de mobilisation. Partenaire : Azad Foundation Pays : Inde Durée : 2017-2020  Plus de  200  ont validé la formation  Partenaire : Swiss Academy for Development Pays : Myanmar Durée : 2017-2019  Dépasser le traumatisme  Pendant 350 sessions, 800 participants ont appris à reconnaître les signes d’un traumatisme et ses effets sur leurs vies. Un soutien financier a été accordé à 28 petites activités commerciales et 8 groupes d’épargne et de crédit.  Le Myanmar a été le théâtre de l’une des guerres civiles les plus longues que le monde ait connu. Les femmes et les enfants en ont été les premières victimes. Ils souffrent aujourd’hui des conséquences psychologiques de ce traumatisme et vivent dans un climat de violence latente et de peur où silence et impunité règnent en maîtres. Dans sept villages de Taungû, Swiss Academy for Development et Karen Women Empowerment Group ont permis à des femmes et des jeunes de surmonter leur traumatisme et faire face à leur détresse mentale à travers l’activité physique, la danse et le jeu de rôle. 26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"27-no1\" class=\"abs brillcutmed 27-no\" style=\"left: 154px; top: 784px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 82, \"append\": \"%\"}'></h1>\n\n      <div class=\"contentLinkNone abs\" style=\"top: 102px; left: 71px; width: 196px; height: 76px;\" onclick=\"Publish.openArticle(9)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 397px; left: 68px; width: 226px; height: 314px;\" onclick=\"Publish.openArticle(9)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 112px; left: 331px; width: 196px; height: 139px;\" onclick=\"Publish.openArticle(10)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 279px; left: 331px; width: 196px; height: 139px;\" onclick=\"Publish.openArticle(10)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 417px; left: 331px; width: 196px; height: 163px;\" onclick=\"Publish.openArticle(10)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 509px; left: 331px; width: 196px; height: 197px;\" onclick=\"Publish.openArticle(10)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 709px; left: 331px; width: 196px; height: 163px;\" onclick=\"Publish.openArticle(10)\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(cOf(\"27-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[0]);}}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n          resetNumbers(\"27-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "Apporter de l’espoir aux femmes entrepreneurs  ASIAN UNIVERSITY FOR WOMEN  Partenaire : CREA Pays : Mexique Durée : 2016-2019  20 jeunes femmes de milieux très défavorisés d’Asie reçoivent une bourse d’étude qui leur permettra d’obtenir un diplôme universitaire et de se faire une place dans les sociétés patriarcales de leur pays.  Bangladesh – 2018−2023  WOMEN FOR WOMEN INT. Kosovo et Rwanda 2017-2020  CREA aide des femmes à développer leurs microentreprises à travers des formations, du mentorat et l’accès à certains services qui leur permettent d’améliorer leurs méthodes de production et de distribution et de trouver de nouveaux débouchés commerciaux. Ce programme de développement commercial a été proposé dans les centres de formation de CREA à Hidalgo, Querétaro, Yucatán, Guerrero et Toluca. Plus de 7 760 femmes ont acquis des nouvelles compétences et ont accédé à de nouvelles sources de financement. Leurs entreprises ont réalisé une augmentation de 10% de leurs profits hebdomadaires.  Taux de survie de  82%  1 350 femmes participent à un programme complet d’émancipation d’une année qui leur permet de sortir de la pauvreté et de l’isolement pour atteindre une autonomie économique et sociale.  PROGRAMMES  EN COURS INTERNATIONAL CENTER FOR RESEARCH ON WOMEN Rwanda et Tanzanie 2019−2014 Une étude de terrain est en cours pour tester des stratégies d’engagement des hommes en les intégrant aux programmes traditionnels de soutien économique et social des femmes. Women for Women Int. au Rwanda et Hand in Hand Int. en Tanzanie dirigent ces programmes auxquels 900 femmes et 470 hommes participent.  MARIE STOPES INT. Sénégal – 2019−2021 Une équipe mobile offre des services de santé sexuelle et reproductive réguliers et gratuits à 12 000 jeunes filles et femmes du nord-ouest du Sénégal. 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 29-title\" style=\"top:249px; left:126px;\" src=\"/AR2019-20/fr/static/_content/29-title-1.png\">        \n      <img class=\"halfScale 29-sub\" style=\"top:374px; left:367px;\" src=\"/AR2019-20/fr/static/_content/29-sub-1.png\">        \n      <div class=\"pointer abs\" style=\"top: 239px; left: 60px; width: 546px; height: 37px;\" onclick=\"Publish.openArticle(11)\"></div>\n      <div class=\"pointer abs\" style=\"top: 277px; left: 358px; width: 296px; height: 37px;\" onclick=\"Publish.openArticle(11)\"></div>\n      <div class=\"pointer abs\" style=\"top: 310px; left: 358px; width: 186px; height: 37px;\" onclick=\"Publish.openArticle(11)\"></div>\n      <div class=\"pointer abs\" style=\"top: 370px; left: 358px; width: 283px; height: 361px;\" onclick=\"Publish.openArticle(11)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(cOf(\"29-title\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"29-sub\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          setTimeout(function(){\n            addContentLinks();\n          }, 1900);\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n        removeContentLinks();\n        Publish.closeArticle();\n\n        }\n      ",
    "searchText": "MODES DE SUBS ISTANCE ET ÉCOSYSTÈMES DURABLES Deux tiers des personnes les plus pauvres au monde vivent en zone rurale et souffrent d’un manque d’accès aux marchés, à l’éducation, à des infrastructures de qualité, aux perspectives d’emploi, aux soins médicaux et aux produits financiers. Pour éradiquer l’extrême pauvreté — et la limiter à moins de 3 % de la population mondiale — nous devons en priorité soutenir les petits fermiers partout dans le monde grâce à des modèles éprouvés qui leur permettent d’acquérir les compétences nécessaires, un salaire décent, une sécurité financière afin d’améliorer leur qualité de vie."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"30-no1\" class=\"abs brillcutreg 30-no\" style=\"left: 564px; top: 529px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;\"  data-number='{\"to\": 8250, \"comma\": \"true\"}'></h1>\n      <h1 id=\"30-no1\" class=\"abs brillcutmed 30-no\" style=\"left: 523px; top: 755px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 56.7, \"decimals\": 1, \"append\": \"%\"}'></h1>\n\n      <img class=\"halfScale 30-text\" style=\"top:478px; left:88px;\" src=\"/AR2019-20/fr/static/_content/30-text-2.png\">        \n      <img class=\"halfScale 30-text\" style=\"top:740px; left:88px;\" src=\"/AR2019-20/fr/static/_content/30-text-3.png\">        \n\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 366px; height: 46px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 136px; left: 321px; width: 326px; height: 46px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 224px; left: 83px; width: 326px; height: 231px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 470px; left: 84px; width: 526px; height: 51px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 520px; left: 84px; width: 464px; height: 87px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 607px; left: 84px; width: 574px; height: 57px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 730px; left: 83px; width: 407px; height: 117px;\" onclick=\"Publish.openArticle(12)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-text\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n          .fromTo(cOf(\"30-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[0]);}}, 1)\n          .fromTo(cOf(\"30-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[1]);}}, \"+=0.2\")\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n          resetNumbers(\"30-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n\n      }\n      ",
    "searchText": "RÉSULTATS ET SUIVI Partenaire : BRAC Pays : Ouganda Durée : 2017-2019 > 2019-2022  Handicap et extrême pauvreté en Ouganda Les causes de la pauvreté sont multiples, c’est pourquoi le programme de formation des personnes les plus pauvres de BRAC s’attaque au problème sur plusieurs fronts. Il fournit aux plus démunis des moyens de production, un soutien financier temporaire pour leur consommation journalière, un accompagnement à la création d’entreprise, des plans d’épargne et un coaching aux aptitudes de vie, ainsi qu’un accès gratuit aux soins. En associant encadrement, transfert de connaissances et de compétences ce programme de 24 mois aide les individus et leurs familles à sortir de l’extrême pauvreté. Entre 2016 et 2019, nous avons soutenu l’adaptation de ce programme en Ouganda, dans les districts extrêmement défavorisés de Luwero et Kiryandongo.  1 650 jeunes parmi les plus démunis ne sont plus en situation de pauvreté extrême et disposent de moyens de subsistance pérennes. Ils ont amélioré objectivement leurs revenus, leur consommation, leurs moyens de production, leur sécurité alimentaire et leur santé, et ont fait de même pour leurs familles.  8 250  personnes au total  Le programme est axé sur l’incitation à l’épargne chez les jeunes. La formation financière donne aux participants les connaissances et les outils nécessaires pour gérer leur argent et planifier leur avenir : 100 associations villageoises d’épargne et de crédit ont été mises sur pied.  2019-2022 Nous maintenons notre soutien à BRAC en Ouganda, où l’organisation mène un projet pilote de formation à destination des plus démunis adapté aux personnes handicapées en partenariat avec Handicap International et la National Union of Women with Disabilities of Uganda. Ensemble, ils devraient permettre à 2 700  personnes et leurs familles de sortir de la pauvreté. 30  Les montants épargnés ont augmenté de  56,7%"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"31-no1\" class=\"abs brillcutmed 31-no\" style=\"left: 540px; top: 375px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 55, \"append\": \"%\"}'></h1>\n      <h1 id=\"31-no1\" class=\"abs brillcutmed 31-no\" style=\"left: 93px; top: 727px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 311, \"append\": \"%\"}'></h1>\n\n      <img class=\"halfScale 31-text\" style=\"top:634px; left:71px;\" src=\"/AR2019-20/fr/static/_content/31-text-2.png\">        \n      <img class=\"halfScale 31-text\" style=\"top:757px; left:239px;\" src=\"/AR2019-20/fr/static/_content/31-text-3.png\">        \n\n      <div class=\"contentLinkNone abs\" style=\"top: 476px; left: 67px; width: 396px; height: 25px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 502px; left: 68px; width: 570px; height: 184px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 750px; left: 233px; width: 394px; height: 97px;\" onclick=\"Publish.openArticle(12)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"31-text\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n          .fromTo(cOf(\"31-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[0]);}}, \"+=0.3\")\n          .fromTo(cOf(\"31-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[1]);}}, \"+=0.2\")\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n          resetNumbers(\"31-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "Partenaire : Village Enterprise Pays : Ouganda Durée : 2016-2019 > 2020-2023  55%  ont augmenté leur valeur  Tracer la voie pour sortir de la pauvreté Le programme de formation à la création de microentreprises de Village Enterprise a déjà démontré son efficacité : il permet de sortir les personnes de la pauvreté extrême en les aidant à développer des moyens de subsistance durables. Les participants, identifiés suite à un classement socio-économique participatif, bénéficient d’une aide financière, de formations en entrepreneuriat et finance, et d’un mentorat continu avec un entrepreneur local. Ils reçoivent aussi un soutien à la création de petites activités commerciales et à la formation de groupes d’épargne et de crédit. Entre 2016 et 2019, 900 entreprises de trois personnes ont été créées, ainsi que 90 groupes d’épargne, ce qui a permis à 2 700 personnes d’accéder à l’autonomie sociale et économique.  311%  d’augmentation de l’épargne des foyers  2020-2023 Nous renouvelons notre soutien à Village Enterprise en Ouganda avec l’objectif de fournir à 2 700 personnes parmi les plus démunies, principalement des femmes, les connaissances, les compétences et la confiance nécessaires pour développer des microentreprises durables. 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"32-no1\" class=\"abs brillcutreg 32-no\" style=\"left: 88px; top: 364px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;\"  data-number='{\"to\": 50, \"append\": \"%\"}'></h1>\n      <h1 id=\"32-no1\" class=\"abs brillcutmed 32-no\" style=\"left: 572px; top: 488px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 3, \"preppend\": \"1/\"}'></h1>\n      <img class=\"halfScale 32-text\" style=\"top:338px; left:225px;\" src=\"/AR2019-20/fr/static/_content/32-text-2.png\">        \n      <img class=\"halfScale 32-text\" style=\"top:520px; left:89px;\" src=\"/AR2019-20/fr/static/_content/32-text-3.png\">        \n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 366px; height: 46px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 136px; left: 321px; width: 326px; height: 46px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 224px; left: 83px; width: 576px; height: 93px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 333px; left: 217px; width: 436px; height: 144px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 518px; left: 84px; width: 366px; height: 65px;\" onclick=\"Publish.openArticle(12)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.staggerFromTo(cOf(\"32-text\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n          .fromTo(cOf(\"32-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[0]);}}, 1)\n          .fromTo(cOf(\"32-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[1]);}}, \"+=0.2\")\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          resetNumbers(\"32-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "RÉSULTATS ET SUIVI Partenaire : One Acre Fund Pays : Rwanda Durée : 2016-2019 > 2020-2023  Des agriculteurs prospères, des communautés dynamiques Le dynamisme des communautés rurales repose sur des petits agriculteurs solides. One Acre Fund propose aux fermiers d’Afrique de l’Est un ensemble de services, dont des semences et engrais améliorés, des financements ainsi que des formations et un accès au marché. Ces services les aident à augmenter leurs rendements sur une saison et, donc, leur qualité de vie. Près de  50%  de femmes  Entre 2016 et 2019, les actions de One Acre Fund ont permis à  390 000 fermiers rwandais d’augmenter leurs revenus de 120 dollars en moyenne par an, améliorant ainsi la qualité de vie de plus de 2 millions de personnes. Au fil des ans, les équipes de One Acre Fund ont établi de bonnes relations de travail avec les autorités rwandaises nationales et locales pour préparer l’expansion de leur modèle.  2020-2023 Pour capitaliser sur ces résultats encourageants, nous financerons les activités de One Acre Fund pour trois années supplémentaires, et ainsi permettre à l’organisation d’améliorer la vie d’1,5 million de fermiers d’ici 2022.  32  1/3  des familles de petits agriculteurs du pays"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"33-no1\" class=\"abs brillcutreg 33-no\" style=\"left: 70px; top: 596px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;\"  data-number='{\"to\": 27, \"append\": \"%\"}'></h1>\n      <h1 id=\"33-no1\" class=\"abs brillcutmed 33-no\" style=\"left: 500px; top: 756px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 6329, \"comma\": \"true\"}'></h1>\n      <img class=\"halfScale 33-text\" style=\"top:546px; left:183px;\" src=\"/AR2019-20/fr/static/_content/33-text-2.png\">        \n      <img class=\"halfScale 33-text\" style=\"top:756px; left:71px;\" src=\"/AR2019-20/fr/static/_content/33-text-3.png\">        \n      <div class=\"contentLinkNone abs\" style=\"top: 185px; left: 66px; width: 365px; height: 345px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 535px; left: 177px; width: 464px; height: 161px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 750px; left: 64px; width: 374px; height: 87px;\" onclick=\"Publish.openArticle(12)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim.staggerFromTo(cOf(\"33-text\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n          .fromTo(cOf(\"33-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"33-no\")[0]);}}, 1)\n          .fromTo(cOf(\"33-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"33-no\")[1]);}}, \"+=0.2\")\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop();\n          resetNumbers(\"33-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "Partenaire : Root Capital Pays : Pérou Durée : 2016-2019 > 2019-2022  Plus de prospérité pour les petits fermiers Les petites entreprises agricoles et les coopératives peuvent être de puissants moteurs de prospérité. Lorsqu’elles se développent et s’épanouissent, les centaines de petits agriculteurs qui y sont associés prospèrent et deviennent plus résilients. En effet, ces entreprises ne fournissent pas seulement des moyens vitaux de subsistance, elles agissent aussi comme des catalyseurs de changement en introduisant des pratiques éco-responsables, en investissant dans l’infrastructure locale, en connectant les familles de fermiers à des marchés plus étendus et en renforçant les communautés locales grâce à des emplois, des formations et de meilleurs revenus. Le modèle « crédit plus compétences » de Root Capital permet d’accorder des prêts aux entreprises qui sont trop grandes pour les institutions de microfinance, mais souvent trop petites et à risque pour obtenir des prêts traditionnels auprès des banques commerciales. Ce soutien financier s’accompagne de formations agronomiques et de conseils financiers sur la bonne gestion des prêts, ainsi que de meilleures connexions avec les marchés. Hausse moyenne de  27%  des revenus  Entre 2016 et 2019, nous avons soutenu les efforts de Root Capital pour réduire la pauvreté rurale au Pérou. En trois ans :  62 coopératives rurales ont reçu des prêts et des conseils financiers. Plus de 33 500 petits exploitants ont augmenté leurs revenus de 16%, améliorant ainsi les conditions de vie de plus de 165 000 membres de leur famille. Grace à la pratique de l’agriculture biologique, de la reforestation et de la diversification agricole 52 115 hectares de terre ont été gérés durablement.  2019-2022 Après une première subvention de trois ans, nous renouvelons notre collaboration avec Root Capital au Pérou afin d’offrir des financements sur-mesure et une assistance technique essentielle à 95 coopératives rurales, ce qui bénéficiera à environ 30 000 petits agriculteurs. 33  Dont  6 329 femmes"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 34-text\" style=\"top:693px; left:88px;\" src=\"/AR2019-20/fr/static/_content/34-text-2.png\">        \n      <img class=\"halfScale 34-text\" style=\"top:805px; left:88px;\" src=\"/AR2019-20/fr/static/_content/34-text-3.png\">        \n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 366px; height: 46px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 136px; left: 321px; width: 326px; height: 46px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 504px; left: 83px; width: 576px; height: 243px;\" onclick=\"Publish.openArticle(12)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 800px; left: 83px; width: 576px; height: 37px;\" onclick=\"Publish.openArticle(12)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.staggerFromTo(cOf(\"34-text\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n\n        }\n\n        function onPageLeave() {\n        removeContentLinks();\n        Publish.closeArticle();\n        }\n      ",
    "searchText": "RÉSULTATS ET SUIVI Partenaire : Kheyti Pays : Inde Durée : 2018-2019 > 2019-2022  Développer une serre révolutionnaire L’agriculture indienne est de moins en moins rentable et de plus en plus sensible au climat, alors que le pays entier en dépend pour se nourrir et qu’elle constitue la première source d’emploi de la population. Kheyti conçoit, produit et vend à un prix abordable des serres modulaires innovantes. L’organisation propose également des services de financement, d’accès aux intrants et aux marchés, et des formations pour améliorer les cultures, la récolte et la vente des produits maraîchers. Kheyti est la seule entreprise à offrir aux petits fermiers cette solution de serre tout-en-un. Nous avons financé les activités de Kheyti, initialement sur une année, afin que l’entreprise puisse démontrer l’efficacité de son modèle. Durant cette période, la « Greenhouse-in-a-box » a permis à 50 petits fermiers de multiplier leurs récoltes par 7 en économisant 90% d’eau. Désormais, 125 fermiers sont équipés de la serre développée par Kheyti.  2019-2022 Nous soutenons Kheyti pour lui permettre d’améliorer davantage son produit et ses services tout en se développant pour servir 10 000 petits fermiers d’ici 2022. 34"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"35-no1\" class=\"abs brillcutreg 35-no\" style=\"left: 70px; top: 581px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;\"  data-number='{\"to\": 57, \"append\": \"%\"}'></h1>\n      <h1 id=\"35-no1\" class=\"abs brillcutreg 35-no\" style=\"left: 70px; top: 624px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;\"  data-number='{\"to\": 79, \"append\": \"%\"}'></h1>\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 66px; width: 306px; height: 46px;\" onclick=\"Publish.openArticle(13)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 154px; left: 390px; width: 256px; height: 553px;\" onclick=\"Publish.openArticle(13)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.fromTo(cOf(\"35-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"35-no\")[0]);}}, 1)\n          .fromTo(cOf(\"35-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"35-no\")[1]);}}, \"+=0.2\")\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n          resetNumbers(\"35-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "RÉSULTATS Former des microentrepreneurs, investir dans leur avenir À Madagascar, les microentreprises Partenaire : IECD Pays : Madagascar informelles Durée : 2017-2019 constituent la source principale de revenus pour la majorité de la population non agricole. Mais souvent les microentrepreneurs ne disposent pas de compétences en gestion et de la vision à moyen terme nécessaires au maintien de leurs activités au-delà de la première année. Au cours des trois dernières années, l’IECD, en partenariat avec l’ONG locale Madagascar Enterprise Development, a offert à 320 créateurs et responsables de petites entreprises une formation de base en gestion ainsi qu’un suivi personnalisé afin de leur permettre d’évaluer la faisabilité de leurs projets et de pérenniser leurs activités, les rendant ainsi plus rentables. De plus, 75 microentrepreneurs extrêmement vulnérables – vendeurs de rue et entrepreneurs illettrés – ont également appris les principes de base de gestion, ce qui les a aidés à stabiliser leurs revenus.  57%  de participants ont augmenté leurs revenus et  79%  ont commencé à épargner  35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 256px; left: 86px; width: 573px; height: 48px;\" onclick=\"Publish.openArticle(14)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 346px; left: 86px; width: 573px; height: 143px;\" onclick=\"Publish.openArticle(14)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n        removeContentLinks();\n        Publish.closeArticle();\n        }\n      ",
    "searchText": "PROGRAMMES EN  COURS  BLUE VENTURES  MYAGRO  Madagascar – 2018-2021  Sénégal – 2019-2022  Des communautés de pêcheurs s’engagent dans la gestion de leurs ressources avec des fermetures temporaires de zones de pêche permettant aux invertébrés de se reconstituer et aux pécheurs d’augmenter leurs prises et leurs revenus.  PROXIMITY DESIGNS Myanmar – 2018-2020 L’accès aux nouvelles techniques d’irrigation améliore les conditions de vie de 30 000 fermiers du delta d’Ayeyarwady et de la Zone sèche du centre du pays.  36  Les cartes prépayées myAgro permettent à 75 000 fermiers dans 528 villages du Sénégal de payer par petites tranches les intrants agricoles et les formations dont ils ont besoin, augmentant ainsi leurs récoltes en moyenne de 50%."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 319px; left: 86px; width: 203px; height: 335px;\" onclick=\"Publish.openArticle(14)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n        removeContentLinks();\n        Publish.closeArticle();\n        }\n      ",
    "searchText": "EDUCATION FOR EMPLOYMENT Maroc – 2019-2020 430 jeunes Marocains acquièrent des compétences techniques et commerciales et des aptitudes de vie pour augmenter leurs chances de décrocher des postes à responsabilité et de s’assurer des revenus suffisants.  TERRE DES HOMMES SUISSE Pérou – 2017-2020 Une coopérative de cacao de la région amazonienne créée par d’anciens orpailleurs s’attache à améliorer sa production agricole, consolider ses stratégies de vente et ses pratiques de gestion, et atteindre l’autosuffisance.  37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 39-title\" style=\"top:243px; left:89px;\" src=\"/AR2019-20/fr/static/_content/39-title-1.png\">        \n      <img class=\"halfScale 39-sub\" style=\"top:373px; left:368px;\" src=\"/AR2019-20/fr/static/_content/39-sub-1.png\">        \n      <div class=\"pointer abs\" style=\"top: 239px; left: 80px; width: 476px; height: 37px;\" onclick=\"Publish.openArticle(15)\"></div>\n      <div class=\"pointer abs\" style=\"top: 277px; left: 358px; width: 266px; height: 67px;\" onclick=\"Publish.openArticle(15)\"></div>\n      <div class=\"pointer abs\" style=\"top: 364px; left: 358px; width: 283px; height: 307px;\" onclick=\"Publish.openArticle(15)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.fromTo(cOf(\"39-title\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"39-sub\"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n        removeContentLinks();\n        Publish.closeArticle();\n        }\n      ",
    "searchText": "RÉPONSE ET PRÉPARATION AUX SITUATIONS D’URGENCE Alors que le monde est aux prises avec la plus grande crise sanitaire depuis un siècle, personne ne doit être laissé pour compte. D’autres épidémies mortelles continuent de faire des ravages, notamment celles d’Ebola ou de la rougeole en République démocratique du Congo. Les services de santé essentiels, en particulier dans les environnements difficiles comme les camps de réfugiés, doivent être maintenus pour sauver des vies et préserver la dignité de chacun."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"40-no1\" class=\"abs brillcutmed 40-no\" style=\"left: 65px; top: 729px; font-size: 1.8em; font-weight:400; margin:0; color:#1c9788; padding:0; margin:0;\"  data-number='{\"to\": 185800, \"comma\": \"true\"}'></h1>\n      <div class=\"contentLinkNone abs\" style=\"top: 82px; left: 81px; width: 583px; height: 46px;\" onclick=\"Publish.openArticle(16)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 149px; left: 315px; width: 336px; height: 306px;\" onclick=\"Publish.openArticle(16)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 469px; left: 241px; width: 406px; height: 28px;\" onclick=\"Publish.openArticle(16)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 499px; left: 241px; width: 416px; height: 338px;\" onclick=\"Publish.openArticle(16)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.fromTo(cOf(\"40-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"40-no\")[0]);}}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          resetNumbers(\"40-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "NOUVEAUX  PROGRAMMES  Sauver des vies, protéger des droits  Partenaire : SOS MÉDITERRANÉE Pays : Mer Méditerranée Durée : 2019-2020  Au cours des six dernières années, plus de 20 000 personnes ont péri ou ont disparu en mer entre la Libye et les côtes méridionales de l’Europe, la voie de migration la plus mortelle au monde. SOS MÉDITERRANÉE est une organisation d’aide humanitaire qui depuis 2019 a affrété le navire de sauvetage Ocean Viking. Elle a pour mission de sauver les personnes en détresse en mer, porter assistance aux survivants à bord et témoigner des réalités de la migration dans la région. La filiale suisse s’attache particulièrement au cadre juridique qui vise à clarifier et actualiser le droit international en matière de droits humains en milieu marin. Depuis le début de ses opérations, SOS MÉDITERRANÉE a porté secours à 31 799 survivants.  Soigner dans des contextes d’insécurité En RDC, MSF intervient dans des zones marquées par des difficultés logistiques et l’insécurité pour répondre à deux importantes épidémies d’Ebola et de rougeole. L’épidémie d’Ebola qui a sévit dans les provinces du Nord-Kivu, Sud-Kivu et Ituri en 2018 a été la pire jamais enregistrée dans le pays, avec 3 324 cas confirmés et 2 287 morts. Nous avons soutenu MSF afin d’offrir des soins gratuits à 1 036 patients dans le centre de traitement Ebola de Bunia. Partenaire : Médecins Sans Frontières (MSF) Pays : République Démocratique du Congo, Niger Durée : 2019-2020  185 800 enfants ont été vaccinés  Une épidémie massive de rougeole ravage aussi le pays depuis mi-2018. 310 000 personnes ont été infectées et 6 000 sont mortes au cours de la seule année 2019. Les équipes de MSF ont traité 13 800 patients et ont mis en place un laboratoire d’analyses et des activités de surveillance pour circonscrire l’épidémie. Au Niger, MSF a fourni des soins de qualité à 16 300 enfants dans l’unité pédiatrique de l’hôpital de Magaria. En 2019 plus de 45 000 enfants ont aussi reçu une assistance médicale dans les communautés environnantes. 40"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"41-no1\" class=\"abs brillcutreg 41-no\" style=\"left: 369px; top: 607px; font-size: 1.6em; font-weight:400; margin:0; color:#1c9788; padding:0; margin:0;\"  data-number='{\"to\": 140000, \"comma\": \"true\"}'></h1>\n      <div class=\"contentLinkNone abs\" style=\"top: 153px; left: 361px; width: 286px; height: 437px; \" onclick=\"Publish.openArticle(17)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"top: 83px; left: 361px; width: 286px; height: 47px; \" onclick=\"Publish.openArticle(17)\"></div>\n      <div class=\"contentLinkNone abs\" style=\"    top: 433px; left: 61px; width: 246px; height: 406px;\" onclick=\"Publish.openArticle(18)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.fromTo(cOf(\"41-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"41-no\")[0]);}}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          resetNumbers(\"41-no\");\n        removeContentLinks();\n        Publish.closeArticle();\n      }\n      ",
    "searchText": "RESULTATS Des services de santé pérennes à Cox Bazar Alors que la situation d’urgence dans les camps de réfugiés de Cox Bazar s’est muée en crise humanitaire prolongée, nous avons soutenu BRAC pour rénover et améliorer un centre de santé et deux dispensaires. Ces structures sanitaires offrent des services essentiels de qualité, en particulier dans le domaine de la santé sexuelle et reproductive, la santé néonatale et infantile, dans la prévention de maladies non transmissibles et la santé mentale. L’accès à des infrastructures améliorées représente une importante avancée dans un contexte extrêmement fragile et précaire. Partenaire : BRAC Pays : Bangladesh Durée : 2018-2020  Partenaire : Médecins Sans Frontières (MSF) Pays : Belgique, Espagne, France, Grèce, Italie, Suisse Durée : 2020  Soutenir la réponse à l’épidémie de COVID-19 en Europe  Entre avril 2019 et février 2020 les équipes de BRAC ont assuré 334 000 consultations médicales, 2 300 accouchements sécurisés et 14 000 consultations de planification familiale. Les équipes médicales de BRAC ont dû faire face à un nombre croissant de cas critiques de rougeole et cholera nécessitant des soins intensifs.  Face à la propagation de l’épidémie de coronavirus en Europe, nous avons soutenu les équipes de MSF afin d’aider les autorités sanitaires nationales et renforcer leurs capacités de prévention, contrôle et traitement des cas. Les activités de MSF se sont concentrées sur les populations en situation précaire telles que les résidents des maisons de retraite, les sans domicile fixe, les migrants, les demandeurs d’asile, les détenus et le personnel pénitentiaire. Des équipes mobiles ont procédé à des activités de consultation et dépistage, ainsi que de diagnostic, d’isolement et de prise en charge des cas dans des structures d’hébergement dédiées. MSF a par ailleurs fourni un soutien psychologique aux travailleurs de santé de première ligne.  140 000  réfugiés ont eu accès à des soins de qualité  41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLinkNone abs\" style=\"top: 786px; left: 82px; width: 208px; height: 21px;\">\n          <a href=\"https://www.cartierphilanthropy.org/\" target=\"_blank\"></a>\n        </div>\n        ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Acronymes AUW		 Asian University for Women BRAC 		  Bangladesh Rural Advancement Committee  FICR		 Fédération internationale des sociétés de la Croix-Rouge et du Croissant-Rouge IECD		 Institut Européen de Coopération et de Développement MSF		 Médecins Sans Frontières PAM		 Programme alimentaire mondial SAD		 Swiss Academy for Development SOIL		 Sustainable Organic Integrated Livelihoods WSUP		  Water and Sanitation for the Urban Poor  Crédits photos Cover: © BOMA Project © Azad Foundation (p. 26) © Blue Ventures / Louise Jasper (p. 36) © BOMA Project / David duChemin (p. 22) © Buildher (p. 23) © Cartier Philanthropy / Andrea Borgarello (p. 13, 16, 18-19, 27-31, 41) © Cartier Philanthropy / Cyril Le Tourneur (p. 10-11, 17-21, 23, 26-27, 36) © Cartier Philanthropy / Irene Amodei (p. 38-39) © Education for Employment (p. 37) © Hand in Hand International / Georgina Goodwin (p. 21) © Healthy Learners (p. 12) © IECD (p. 14, 35) © IECD / Rijasolo (p. 17) © Kheyti (p. 34) © Living Goods / Martina Bacigalupo (p. 18) © mothers2mothers / Karin Schermbrucker (p. 24)  Adresse Rue André-De-Garrini 3 - CH-1217 Meyrin-Genève  Site internet www.cartierphilanthropy.org  © MSF / Caroline Thirion (p. 40) © MSF / Clément Mahoudeau (p. 41) © MUSO / Lucas Foglia (p. 15) © myAgro / Christien van den Brink (p. 36) © One Acre Fund / Evariste Babambiki (p. 32) © PAM / Roberto Masiero (p. 18) © PAM / Esther Ouba (p. 18) © Rosie Hallam (p. 19, courtesy of Luminos Fund) © Root Capital (p. 33) © Saha Global (p. 14) © Santé Integrée (p. 19) © SOIL (p. 15) © SOS MÉDITÉRRANÉE / Anthony Jean (p. 40) © StrongMinds / Jennifer Bass (p. 25) © Terre des Hommes Suisse / Jérômine Derigny (p. 37) © Women for Women International / Hazel Thomson (p. 27) © WSUP / Tsilavo Rapiera (p. 18)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \" \";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null,
  "articles": [{
    "title": "MESSAGE DU PRÉSIDENT",
    "pageIndex": 7,
    "subIndex": 0,
    "articleIndex": 0,
    "article": "\n      <h2 style=\"color:#1d1d1b\">MESSAGE DU PR\xC9SIDENT</h2>  \n      <p>\n      Quelle est la place du m\xE9c\xE9nat d\u2019entreprise dans notre soci\xE9t\xE9 ?\n      </p>\n      <p>\n      La question est ancienne, et ses r\xE9ponses multiples.\n      </p>\n      <p>\n      L\u2019engagement philanthropique de Cartier envers la soci\xE9t\xE9 s\u2019exprime \xE0 travers Cartier Philanthropy pour donner une dimension concr\xE8te \xE0 nos valeurs : g\xE9n\xE9rosit\xE9, confiance, respect et compassion. La fondation illustre notre implication sans \xE9quivoque dans la construction d\u2019un monde plus inclusif et \xE9quitable, tout comme Cartier Women\u2019s Initiative et d\u2019autres actions fortes de notre Maison.      </p>\n      <p>\n      Tout au long de l\u2019ann\xE9e, Cartier Philanthropy s\u2019\xE9vertue \xE0 apporter des solutions aux d\xE9fis les plus pr\xE9gnants dans les r\xE9gions les moins d\xE9velopp\xE9es du monde, nous rappelant ainsi que nous avons tous, individus comme entreprises, le potentiel \u2014 et donc le devoir \u2014 d\u2019agir. \xC0 travers ses initiatives, la fondation nous encourage \xE0 faire face aux menaces, m\xEAme les plus redoutables, avec rigueur et d\xE9termination. Pas parce que c\u2019est ce que l\u2019on attend de nous. Pas pour faire la une. Mais parce que c\u2019est notre responsabilit\xE9 de citoyens du monde.\n      </p>\n      <p>\n      \xC0 l\u2019heure o\xF9 j\u2019\xE9cris ces lignes, l\u2019humanit\xE9 affronte la pand\xE9mie du coronavirus. Partout, des gens se battent pour endiguer la maladie, sauver des vies, et maintenir leurs moyens de subsistance.      </p>\n      <p>\n      Le virus nous a rappel\xE9 que, quels que soient nos sentiments de faiblesse et de vuln\xE9rabilit\xE9 face au danger, nous sommes toujours entour\xE9s de personnes plus vuln\xE9rables que nous. Notre aide leur est essentielle.      </p>\n      <p>\n      Nous ne pouvions donc que nous associer \xE0 l\u2019effort humanitaire international d\xE9ploy\xE9 en Europe, en Am\xE9rique du Nord et du Sud, en Chine, au Moyen-Orient et en Asie du Sud-Est. Cet imp\xE9ratif s\u2019est naturellement impos\xE9 dans la logique de l\u2019approche philanthropique de Cartier, enracin\xE9e dans la compassion, le pragmatisme et l\u2019ouverture d\u2019esprit.      </p>\n      <p>\n      Nous n\u2019avons pourtant pas d\xE9tourn\xE9 notre attention des plus vuln\xE9rables. Comme vous le lirez dans ce rapport, nous avons \xE9largi notre champ d\u2019action pour soutenir le travail fourni sans rel\xE2che par M\xE9decins Sans Fronti\xE8res et d\u2019autres organisations afin de venir en aide \xE0 celles et ceux qui sont ou \xE9taient dans le besoin en Italie, en France, en Belgique, en Espagne, en Suisse et en Gr\xE8ce.      </p>\n      <p>\n      Une fois encore, Cartier Philanthropy nous a permis de r\xE9pondre rapidement \xE0 une crise sans pr\xE9c\xE9dent, unis dans un esprit de solidarit\xE9 pour agir efficacement en ces temps difficiles.      </p>\n      <p>\n        <b>Cyrille Vigneron </b><br>\n        Pr\xE9sident du conseil de fondation, Cartier Philanthropy <br>\n      PDG de Cartier<br>\n      </p>\n    "
  }, {
    "title": "LETTRE DE LA DIRECTRICE EXÉCUTIVE",
    "pageIndex": 8,
    "subIndex": 0,
    "articleIndex": 1,
    "article": "\n      <h2 style=\"color:#1d1d1b\">LETTRE DE LA DIRECTRICE EX\xC9CUTIVE</h2> \n      <p>\n      Pendant des mois, le monde entier a retenu son souffle alors que le coronavirus se propageait, \xE9voluait et que nous apprenions \xE0 y faire face. \n      </p>\n      <p>\n      Il serait impossible d\u2019\xE9luder dans cette lettre une des pires crises sanitaires que le monde ait jamais connues, une pand\xE9mie dont la port\xE9e internationale a peu d\u2019\xE9quivalents dans l\u2019Histoire de l\u2019humanit\xE9.\n      </p>\n      <p>\n      Cependant, il serait profond\xE9ment injuste de r\xE9duire douze mois de travail passionn\xE9 \xE0 cette urgence, aussi in\xE9dite soit-elle.\n      </p>\n      <p>\n      On entend souvent dire que la crise du coronavirus a tout chang\xE9, mais, dans certains cas, elle n\u2019a fait qu\u2019accentuer des tendances et des faiblesses existantes, tout en braquant les projecteurs sur les d\xE9faillances majeures de notre soci\xE9t\xE9. Nombre de ces d\xE9fis sont ceux auxquels Cartier Philanthropy s\u2019engage \xE0 r\xE9pondre dans le cadre de sa mission en finan\xE7ant des organisations partenaires extr\xEAmement efficaces dont les actions am\xE9liorent concr\xE8tement les vies des plus vuln\xE9rables.\n      </p>\n      <p>\n      L\u2019identification et le financement d\u2019organisations audacieuses et novatrices avec lesquelles \xE9tablir des alliances \xE0 long terme est au c\u0153ur de notre action afin d\u2019assurer un impact social maximal. Nous sommes convaincus qu\u2019il est de notre devoir de les servir au mieux afin qu\u2019elles puissent mettre leurs solutions \xE0 la disposition du plus grand nombre. Ces organisations ont besoin non seulement que nous fassions preuve de flexibilit\xE9 et de pragmatisme, mais aussi que nous pr\xEAtions une oreille attentive \xE0 leurs besoins et leurs difficult\xE9s. En d\u2019autres termes, nous travaillons pour elles, pas l\u2019inverse.\n      </p>\n      <p>\n      Notre mani\xE8re de proc\xE9der n\u2019a pas chang\xE9 quand le coronavirus a frapp\xE9 et elle ne changera pas une fois que la crise sera termin\xE9e. C\u2019est ce que refl\xE8tent les divers partenariats que nous avons renouvel\xE9s cette ann\xE9e (8) ainsi que les profils des sept organisations qui ont rejoint notre portfolio. Je vous invite \xE0 d\xE9couvrir leur travail remarquable dans le rapport de cette ann\xE9e.\n      </p>\n      <p>\n        <b>Pascale de la Fr\xE9gonni\xE8re</b><br>\n        Directrice ex\xE9cutive<br>\n      </p>\n    "
  }, {
    "title": "ACCÈS AUX SERVICES DE BASE",
    "pageIndex": 9,
    "subIndex": 0,
    "articleIndex": 2,
    "article": "\n      <h2 style=\"color:#C9252C\">ACC\xC8S AUX SERVICES DE BASE</h2>  \n      <img src=\"/AR2019-20/fr/static/_content/article-2-1.jpg\">\n      <p>\n      Chaque jour, m\xEAme en ces temps incertains et difficiles, des organisations s\u2019engagent pour am\xE9liorer l\u2019acc\xE8s  \xE0 une \xE9ducation de qualit\xE9, aux soins  de sant\xE9 primaires, \xE0 l\u2019eau potable,  \xE0 une bonne hygi\xE8ne et \xE0 une alimentation \xE9quilibr\xE9e. Cependant, le rythme de ces am\xE9liorations doit s\u2019acc\xE9l\xE9rer si nous voulons faire  en sorte que chaque personne  puisse mener une existence saine  et \xE9panouissante.\n      </p>\n      \n    "
  }, {
    "title": "ACCÈS AUX SERVICES DE BASE: NOUVEAUX PROGRAMMES ",
    "pageIndex": 9,
    "subIndex": 0,
    "articleIndex": 3,
    "article": "\n      <h2 style=\"color:#C9252C\">NOUVEAUX PROGRAMMES </h2>  \n      \n      <h3>Veiller sur la sant\xE9 des \xE9l\xE8ves pour leur permettre d\u2019apprendre</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-3-1.jpg\">\n      <i>Partenaire : Healthy Learners | Pays : Zambie | Dur\xE9e : 2019-2022</i>\n      <p>\n      En Zambie, pr\xE8s de 40 % des enfants en \xE2ge d\u2019\xEAtre scolaris\xE9s manquent r\xE9guli\xE8rement les cours \xE0 cause de maladies que l\u2019on peut soigner et \xE9viter, qui affectent leur d\xE9veloppement et peuvent entrainer le d\xE9crochage scolaire. Healthy Learners aide les \xE9coles \xE0 devenir des points d\u2019acc\xE8s aux soins pour les enfants. Certains professeurs re\xE7oivent une formation d\u2019agent de sant\xE9 et sont ainsi en mesure de surveiller la sant\xE9 des \xE9l\xE8ves, d\u2019\xE9valuer l\u2019\xE9tat des enfants souffrants, de prodiguer des soins de base et d\u2019envoyer les enfants malades au centre  de sant\xE9, ainsi que les jeunes filles n\xE9cessitant un suivi  en sant\xE9 sexuelle et reproductive.\n      </p>\n      <p>\n      Nous soutenons les efforts de Healthy Learners pour  assurer un acc\xE8s aux soins (38% de r\xE9duction de la morbidit\xE9) \xE0 285 000 enfants fr\xE9quentant les \xE9coles primaires publiques des provinces de Lusaka  et de Copperbelt d\u2019ici 2022.\n      \n      <h3>Priorit\xE9 \xE0 l\u2019\xE9ducation  secondaire des filles </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-3-2.jpg\">\n      <i>Partenaire : Room to Read | Pays : Bangladesh, Cambodge | Dur\xE9e : 2019-2022</i>\n      <p>\n      Au Bangladesh et au Cambodge, les pr\xE9jug\xE9s culturels, les discriminations de genre, l\u2019ins\xE9curit\xE9, le besoin de contribuer aux revenus familiaux et l\u2019injonction \xE0 se marier et \xE0 cr\xE9er une famille entravent fortement la r\xE9ussite scolaire des filles, en particulier dans le secondaire.\n      </p>\n      <p>\n      Le programme d\u2019\xE9ducation pour les filles de Room to Read permet aux \xE9l\xE8ves de poursuivre leur scolarit\xE9 (En 2018, 98% des \xE9l\xE8ves qui ont b\xE9n\xE9fici\xE9 du programme au Bangladesh et 77% des \xE9l\xE8ves cambodgiennes ont poursuivi des \xE9tudes sup\xE9rieures.) plus longtemps et d\u2019acqu\xE9rir au terme de leurs \xE9tudes secondaires les connaissances, les aptitudes et les capacit\xE9s qui leur permettront de r\xE9ussir \xE0 l\u2019\xE9cole et dans la vie. Encadr\xE9 par des femmes de leurs communaut\xE9s, le programme propose des s\xE9ances sur les aptitudes \xE0 la vie quotidienne, du mentorat individuel et en groupe, un syst\xE8me de soutien social et une prise en charge qui, selon les besoins, inclut les frais scolaires et de transport, les uniformes et la pr\xE9paration aux examens.       </p>\n      <p>\n      Nous soutenons Room to Read afin d\u2019offrir \xE0 4 350 jeunes bangladeshies et cambodgiennes la possibilit\xE9 de terminer leurs \xE9tudes secondaires et r\xE9aliser leur potentiel.\n      </p>\n      \n      <h3>Lutter contre la malnutrition au Guatemala</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-3-3.jpg\">\n      <i>Partenaire : Semilla Nueva | Pays : Guatemala | Dur\xE9e : 2019-2021</i>\n      <p>\n      Au Guatemala, les tortillas de ma\xEFs sont au menu de chaque repas. Malheureusement, elles sont pauvres en nutriments. Semilla Nueva produit et commercialise des semences de ma\xEFs bio-fortifi\xE9es, enrichies de mani\xE8re traditionnelle en prot\xE9ines de qualit\xE9 et zinc. Les cultures bio-fortifi\xE9es constituent une solution efficace et culturellement adapt\xE9e contre la malnutrition chronique au Guatemala puisqu\u2019elles n\u2019alt\xE8rent pas le r\xE9gime alimentaire traditionnel.\n      </p>\n      <p>\n      \xC0 la suite d\u2019une premi\xE8re subvention de trois ans (Plus de 1 270 sacs de semences ont \xE9t\xE9 vendus en 2018, ce qui signifie que plus de 70 800 personnes ont consomm\xE9 du ma\xEFs enrichi en nutriments pendant un an.),nous renouvelons notre soutien \xE0 Semilla Nueva afin  de g\xE9n\xE9raliser la consommation de ma\xEFs bio-fortifi\xE9  et de fournir \xE0 255  000 personnes du ma\xEFs plus riche en nutriments.\n      </p>\n      \n      <h3>Un centre pour les enfants  syriens r\xE9fugi\xE9s au Liban</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-3-4.jpg\">\n      <i>Partenaire : IECD | Pays : Liban | Dur\xE9e : 2019-2023</i>\n      <p>\n      Le conflit syrien, qui a entra\xEEn\xE9 des d\xE9placements massifs de population, fait peser une pression consid\xE9rable sur les pays d\u2019accueil et plus particuli\xE8rement sur leurs syst\xE8mes \xE9ducatifs. Au Liban, malgr\xE9 les efforts consentis par le minist\xE8re de l\u2019\xC9ducation, qui autorise l\u2019inscription gratuite dans les \xE9coles publiques sans exiger de permis de r\xE9sidence, plus de 300 000 enfants syriens r\xE9fugi\xE9s restent non scolaris\xE9s.\n      </p>\n      <p>\n      Le Centre Janah \xE0 Beyrouth accueille les enfants et adolescents issus de familles d\xE9favoris\xE9es tant syriennes que libanaises. En proposant un soutien scolaire, des activit\xE9s extrascolaires et un soutien psychosocial,  le centre aide les enfants \xE0 r\xE9int\xE9grer l\u2019\xE9cole et \xE0 r\xE9ussir leur scolarit\xE9.\n      </p>\n      <p>\n      Notre contribution permettra \xE0 535 enfants et jeunes pendant trois ans de recevoir un soutien scolaire, participer \xE0 des activit\xE9s de d\xE9veloppement personnel et b\xE9n\xE9ficier \xE9galement d\u2019un transport gratuit et d\u2019un go\xFBter quotidien.\n      </p>\n      \n      <h3>L\u2019eau propre : une affaire de femme</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-3-5.jpg\">\n      <i>Partenaire : Saha Global | Pays : Ghana | Dur\xE9e : 2019-2022</i>\n      <p>\n      Dans le nord du Ghana les populations n\u2019ont pas acc\xE8s \xE0 l\u2019eau potable. Les villages d\xE9pendent du ruissellement de l\u2019eau de pluie qui s\u2019accumule dans de grands \xE9tangs stagnants. Mais cette eau, boueuse et insalubre, repr\xE9sente un risque important pour leur sant\xE9.\n      </p>\n      <p>\n      Saha Global s\u2019efforce d\u2019introduire une technologie de traitement de l\u2019eau simple et abordable dans les communaut\xE9s les plus pauvres et recul\xE9es du pays.\n      </p>\n      <p>\n      Son objectif est de former les femmes dans les villages pour qu\u2019elles puissent \xE9tablir et maintenir des petites entreprises de traitement de l\u2019eau afin d\u2019approvisionner leurs communaut\xE9s  en eau potable au co\xFBt abordable et ainsi g\xE9n\xE9rer des revenus. \n      </p>   \n      <p>\n      Nous soutenons Saha Global pour mettre en place pr\xE8s de  1 000 nouvelles microentreprises de traitement de l\u2019eau destin\xE9es  \xE0 desservir environ 440 000 personnes d\u2019ici \xE0 la fin 2022.      \n      </p>   \n      \n      <h3>La sant\xE9 n\u2019attend pas </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-3-6.jpg\">\n      <i>Partenaire : Muso | Pays : Mali | Dur\xE9e : 2019-2022</i>\n      <p>\n      Le Mali pr\xE9sente un des plus haut taux de mortalit\xE9 des enfants de moins de 5 ans dans le monde. Depuis 2008, Muso collabore avec le gouvernement pour transformer la mani\xE8re dont les soins de sant\xE9 sont dispens\xE9s afin de pouvoir traiter les malades quelques heures apr\xE8s l\u2019apparition des premiers sympt\xF4mes. Ce \xABmod\xE8le de soins de sant\xE9 proactifs \xBB consiste \xE0 former des agents de sant\xE9 communautaire qui se rendent dans les villages pour rep\xE9rer et soigner gratuitement les personnes malades \xE0 domicile, ou les mettre en contact avec des cliniques publiques comp\xE9tentes.\n      </p>\n      <p>\n      Dans les communaut\xE9s o\xF9 ce syst\xE8me a \xE9t\xE9 mis en \u0153uvre, la mortalit\xE9 des enfants a chut\xE9 massivement. (Dans les communaut\xE9s de la p\xE9riph\xE9rie de Bamako, la mortalit\xE9 des enfants a \xE9t\xE9 r\xE9duite de 93% en  trois ans !)\n      </p>\n      <p>\n      Notre soutien va permettre la constitution d\u2019une \xE9quipe technique d\xE9di\xE9e aupr\xE8s de gouvernements, d\xE9cideurs politiques et personnel de sant\xE9 au Mali et hors de ses fronti\xE8res pour assurer l\u2019adoption des soins de sant\xE9 proactifs.Muso envisage de servir 450 000 patients directement et 18 millions de patients indirectement au cours des trois prochaines ann\xE9es.\n      </p>\n      \n      <h3>Des toilettes \xE9cologiques pour une sant\xE9 durable</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-3-7.jpg\">\n      <i>Partenaire : SOIL | Pays : Ha\xEFti | Dur\xE9e : 2019-2022</i>\n      <p>\n      En Ha\xEFti, 66 % des habitants des zones urbaines n\u2019ont pas acc\xE8s \xE0 des installations sanitaires et moins de 1 % des excr\xE9ments sont trait\xE9s en toute s\xE9curit\xE9. Le manque de toilettes a engendr\xE9 une crise sanitaire publique majeure : Ha\xEFti a le taux de diarrh\xE9e infantile le plus \xE9lev\xE9 au monde. Depuis 2006, SOIL travaille dans le pays pour y promouvoir la sant\xE9 et des moyens de subsistance durables. Gr\xE2ce \xE0 ses installations sanitaires s\xFBres, l\u2019organisation collecte et transforme les excr\xE9ments en compost \xE0 haute valeur agricole.\n\n      </p>\n      <p>\n      Nous soutenons SOIL avec l\u2019objectif de fournir \xE0 12  000 Ha\xEFtiens des installations sanitaires \xE0 faible co\xFBt qui associent des toilettes s\xE8ches \xE0 des services de traitement et de transformation des d\xE9chets. \n      </p>\n\n    "
  }, {
    "title": "ACCÈS AUX SERVICES DE BASE: RÉSULTATS",
    "pageIndex": 15,
    "subIndex": 0,
    "articleIndex": 4,
    "article": "\n      <h2 style=\"color:#C9252C\">R\xC9SULTATS</h2>  \n      \n      <h3>Pr\xE9venir le chol\xE9ra dans les communaut\xE9s de p\xEAcheurs de l\u2019Ouganda</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-4-1.jpg\">\n      <i>Partenaire : FICR | Pays : Ouganda | Dur\xE9e : 2017-2019</i>\n      <p>\n      Le chol\xE9ra est end\xE9mique sur les rives  du lac Albert. La p\xEAche constitue  la principale activit\xE9 \xE9conomique de la r\xE9gion et l\u2019acc\xE8s \xE0 l\u2019eau et \xE0 l\u2019assainissement est extr\xEAmement limit\xE9. Nous avons soutenu la Croix-Rouge pour am\xE9liorer durablement les conditions de vie et l\u2019\xE9tat de sant\xE9 de 10 000 habitants du rift Albertin, au nord-ouest de l\u2019Ouganda, en portant une attention particuli\xE8re \xE0 l\u2019adoption de bonnes pratiques d\u2019hygi\xE8ne, \xE0 l\u2019approvisionnement en eau potable et \xE0 l\u2019installation de sanitaires ad\xE9quats.\n      </p>\n      <p>\n      Des agents de sant\xE9 b\xE9n\xE9voles de la Croix-Rouge ont sensibilis\xE9 \xE0 l\u2019hygi\xE8ne plus de 65 700 personnes,entra\xEEnant une hausse de 38 % de  la construction et de l\u2019utilisation  de latrines priv\xE9es, de sanitaires,  de s\xE9choirs, de points de lavage des mains et de fosses \xE0 d\xE9chets.\n      </p>\n      <p>\n      La couverture en installations sanitaires des centres de sant\xE9 et des \xE9coles de la r\xE9gion a \xE9t\xE9 fortement am\xE9lior\xE9e. (De 51% \xE0 89%).\n      </p>\n      <p>\n      Plus de 9 200 personnesont pu acc\xE9der \xE0 de l\u2019eau potable gr\xE2ce \xE0 la construction et r\xE9habilitation de 8 puits et l\u2019ajout de 6 kilom\xE8tres de conduites au syst\xE8me d\u2019alimentation en eau.\n      </p>\n      \n      <h3>Surmonter les distances pour am\xE9liorer la sant\xE9 des enfants</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-4-2.jpg\">\n      <i>Partenaire : Amref | Pays : S\xE9n\xE9gal | Dur\xE9e : 2016-2019</i>\n      <p>\n      Au S\xE9n\xE9gal, la concentration des m\xE9decins g\xE9n\xE9ralistes et des sp\xE9cialistes dans les h\xF4pitaux de la capitale entra\xEEne une grande disparit\xE9 entre les services m\xE9dicaux et chirurgicaux disponibles \xE0 Dakar et dans les zones recul\xE9es du Sud.En cinq ans, l\u2019Amref est parvenu \xE0 renforcer l\u2019acc\xE8s aux soins pr\xE9ventifs essentiels ainsi qu\u2019aux soins sp\xE9cialis\xE9s pour plus de 35 000 enfants dans  60 \xE9coles primaires et plus de 50 postes de sant\xE9  de Kolda et de S\xE9dhiou. \n      </p>\n      <p>\n      160 missions de d\xE9pistage ont \xE9t\xE9 organis\xE9es dans les \xE9coles et les centres de sant\xE9 pour la d\xE9tection pr\xE9coce et le traitement des maladies infantiles les plus communes\n      </p>\n      <p>\n      1 558 enfants ont re\xE7u un suivi m\xE9dical gratuit et de qualit\xE9 dans le cadre de 9 camps de chirurgie et 12 mini-camps de consultations sp\xE9cialis\xE9es.\n\n      </p>\n      <p>\n        37 500 femmes en \xE2ge de procr\xE9er ont renforc\xE9 leurs connaissances et leurs comp\xE9tences en mati\xE8re de sant\xE9 reproductive, sant\xE9 des enfants, hygi\xE8ne  et nutrition.\n      </p>\n      \n      <h3>R\xE9duire l\u2019abandon scolaire \xE0 Madagascar</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-4-3.jpg\">\n      <i>Partenaire : IECD | Pays : Madagascar | Dur\xE9e : 2017-2019</i>\n\n      <p>\n      Le niveau d\u2019instruction \xE0 Madagascar compte parmi les plus bas du monde ; les enfants y sont scolaris\xE9s en moyenne pendant quatre ans seulement. Dans les communaut\xE9s rurales, tout juste 19 % des enfants poursuivent des \xE9tudes secondaires  et ils ne sont que 1 % \xE0 obtenir leur baccalaur\xE9at.\n      </p>\n      <p>\n      Depuis 2006, l\u2019IECD et l\u2019association malgache PROMES collaborent pour r\xE9duire le d\xE9crochage scolaire dans les communaut\xE9s rurales en cr\xE9ant des centres de soutien qui proposent un accompagnement individuel scolaire et extrascolaire des \xE9l\xE8ves. Nous avons financ\xE9 trois centres  dans la r\xE9gion de Fianarantsoa pour  soutenir 360 \xE9l\xE8ves (80% ont r\xE9ussi l\u2019examen  du BEPC alors que le taux  de r\xE9ussite moyen national s\u2019\xE9l\xE8ve \xE0 53 %.) pendant trois ans.\n      </p>\n    "
  }, {
    "title": "ACCÈS AUX SERVICES DE BASE: PROGRAMMES EN COURS",
    "pageIndex": 17,
    "subIndex": 0,
    "articleIndex": 5,
    "article": "\n      <h2 style=\"color:#C9252C\">PROGRAMMES EN COURS</h2>  \n      \n      <h3 class=\"article-mini-header\">LIVING GOODS </h3>\n      <i>Kenya \u2013 2018-2020</i>\n      <p>\n      270  agents  de  sant\xE9  commu-nautaire   prodiguent   des   soins   de  qualit\xE9  \xE0  domicile  \xE0  plus  de  220 000 personnes \xE0 l\u2019ouest du Kenya.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-1.jpg\">\n      \n      <h3 class=\"article-mini-header\">WATER AND SANITATION\n        FOR THE URBAN POOR</h3>\n      <i>Madagascar \u2013 2017-2020</i>\n      <p>\n      WSUP   collabore   avec   la   com-pagnie   nationale   des   eaux   et   les   communaut\xE9s   locales   pour   concevoir  des  services  d\u2019appro-visionnement  en  eau  et  d\u2019assai-nissement   desservant   plus   de   60 000 habitants des bidonvilles urbains de Tananarive.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-2.jpg\">\n      \n      <h3 class=\"article-mini-header\">FICR</h3>\n      <i>Myanmar, Cambodge \u2013\n        2017-2020 </i>\n      <p>\n      La  Croix-Rouge  collabore  avec  des  communaut\xE9s  locales  pour  assurer \xE0 36 000 personnes l\u2019ac-c\xE8s  \xE0  l\u2019eau  potable,  et  \xE0  39  000  l\u2019acc\xE8s  \xE0  des  installations  sani-taires  adapt\xE9es  et  \xE0  de  bonnes  pratiques d\u2019hygi\xE8ne.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-3.jpg\">\n      \n      <h3 class=\"article-mini-header\">PROGRAMME ALIMENTAIRE MONDIAL</h3>\n      <i>Mozambique \u2013 2017-2020       </i>\n      <p>\n      2  000  petits  agriculteurs  produi-sant   du   ma\xEFs,   des   haricots   et   des  l\xE9gumes  frais  pour  les  repas  scolaires  d\xE9couvrent  des  solu-tions  simples  et  abordables  qui  leur permettent de r\xE9duire leurs pertes   post-r\xE9colte   et   d\u2019aug-menter leurs revenus.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-4.jpg\">\n      \n      <h3 class=\"article-mini-header\">PROGRAMME ALIMENTAIRE MONDIAL</h3>\n      <i>Burkina Faso \u2013 2014-2020</i>\n      <p>\n      Une  cha\xEEne  d\u2019approvisionnement  en produits laitiers dirig\xE9e par des femmes  relie  les  petits  \xE9leveurs  et   les   producteurs   locaux   \xE0   71  cantines  scolaires  o\xF9  12  500  \xE9l\xE8ves re\xE7oivent du yaourt frais pour leur collation du matin.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-5.jpg\">\n      \n      <h3 class=\"article-mini-header\">PROGRAMME ALIMENTAIRE MONDIAL</h3>\n      <i>Jordanie \u2013 2018-2021 </i>\n      <p>\n      6  000  enfants  re\xE7oivent  chaque  jour  des  repas  scolaires  gr\xE2ce  \xE0  l\u2019initiative  \xABHealthy  Kitchen\xBB  qui  fournit  un  emploi  \xE0  30  r\xE9fugi\xE9s  syriens et jordaniens en situation pr\xE9caire.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-6.jpg\">\n      \n      <h3 class=\"article-mini-header\">EDUCATE GIRLS \n      </h3>\n      <i>Inde \u2013 2014-2020 </i>\n      <p>\n      Educate  Girls  stimule  la  scolarisa-tion  des  filles,  promeut  des  infra-structures  \xE9ducatives  adapt\xE9es  et  am\xE9liore  les  r\xE9sultats  scolaires  de  100 000 enfants dans 1 053 villages du district de Rajsamand.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-7.jpg\">\n      \n      <h3 class=\"article-mini-header\">SANT\xC9 INT\xC9GR\xC9E</h3>\n      <i>Togo \u2013 2019-2021</i>\n      <p>\n      Sant\xE9  Int\xE9gr\xE9e  a  cr\xE9\xE9  un  mod\xE8le  communautaire  abordable  permet-tant  d\u2019assurer  \xE0  240  000  togolais  l\u2019acc\xE8s aux soins de sant\xE9 primaires de qualit\xE9.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-8.jpg\">\n      \n      <h3 class=\"article-mini-header\">VISIONSPRING \n      </h3>\n      <i>Bangladesh \u2013 2018-2021</i>\n      <p>\n      VisionSpring s\u2019est associ\xE9 \xE0 BRAC au Bangladesh pour fournir des lunettes r\xE9sistantes,  esth\xE9tiques  et  aborda-bles  \xE0  plus  de  600  000  personnes  \xE0  faible revenu.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-9.jpg\">\n      \n      <h3 class=\"article-mini-header\">LUMINOS FUND \n      </h3>\n      <i>\xC9thiopie \u2013 2018-2021 \n      </i>\n      <p>\n      10   000   enfants   \xE9thiopiens   vivant   dans   les   r\xE9gions   recul\xE9es   d\u2019Afar   et  d\u2019Oromiya  r\xE9int\xE9greront  l\u2019ensei-gnement  public  au  terme  d\u2019un  pro-gramme d\u2019apprentissage intensif de 10 mois.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-5-10.jpg\">\n      \n    "
  }, {
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES",
    "pageIndex": 21,
    "subIndex": 0,
    "articleIndex": 6,
    "article": "\n      <h2 style=\"color:#16BECF\">D\xC9VELOPPEMENT SOCIALET \xC9CONOMIQUE DES FEMMES</h2>  \n      <img src=\"/AR2019-20/fr/static/_content/article-6-1.jpg\">\n      <p>\n      Les in\xE9galit\xE9s de genre ne sont pas seulement le produit de normes sociales discriminatoires, de d\xE9s\xE9quilibres de pouvoir et d\u2019obstacles juridiques. Elles racontent aussi \u2014 et surtout \u2014 l\u2019histoire des partis pris et des pr\xE9jug\xE9s \xE0 l\u2019encontre des femmes, port\xE9s par les hommes comme  par les femmes, une histoire qui se r\xE9p\xE8te encore et encore.\n      </p>\n      <p>\n      Pour d\xE9manteler les in\xE9galit\xE9s structurelles, nous devons agir \xE0 plusieurs niveaux et dans divers contextes \u2014 dans les foyers,  les \xE9coles, sur les lieux de travail et dans la fonction publique \u2014 en soutenant les femmes et les filles dans leur lutte pour l\u2019obtention de places qui leur reviennent de plein droit.\n      </p>\n      \n    "
  }, {
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: NOUVEAUX PROGRAMMES ",
    "pageIndex": 21,
    "subIndex": 0,
    "articleIndex": 7,
    "article": "\n      <h2 style=\"color:#16BECF\">NOUVEAUX PROGRAMMES </h2>  \n      \n      <h3>Combattre la pauvret\xE9 dans les zones arides d\u2019Afrique </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-7-1.jpg\">\n      <i>Partenaire : BOMA Project | Pays : Kenya | Dur\xE9e : 2019-2021</i>\n      <p>\n      Dans les r\xE9gions arides et semi-arides du nord du Kenya, des familles d\u2019\xE9leveurs vivent sans eau courante ni \xE9lectricit\xE9, \xE0 des kilom\xE8tres des commerces, des routes asphalt\xE9es, des transports publics, des \xE9coles et des centres de sant\xE9 les plus proches. Le b\xE9tail constitue leur source principale de revenus. Des mois durant, les hommes voyagent loin avec leurs troupeaux \xE0 la recherche d\u2019eau et de p\xE2turage, deux ressources rares. Les femmes restent au village, prisonni\xE8res d\u2019une pauvret\xE9 extr\xEAme et d\u2019une ins\xE9curit\xE9 alimentaire chronique.\n      </p>\n      <p>\n      Avec des interventions s\xE9quenc\xE9es qui incluent des formations  pour d\xE9velopper des comp\xE9tences et des connaissances,  BOMA Project permet aux femmes les plus pauvres de cr\xE9er des entreprises et des groupes d\u2019\xE9pargne (+ 1 400% d\u2019\xE9conomies), de renforcer la s\xE9curit\xE9 financi\xE8re et alimentaire de leur foyer, d\u2019investir dans la sant\xE9 (+ 258% de d\xE9penses m\xE9dicales annuelles) et l\u2019\xE9ducation de leurs enfants, et d\u2019imposer un peu plus leur voix. Nous soutenons BOMA Project pour permettre \xE0 500 000 femmes  et enfants d\u2019am\xE9liorer leurs conditions de vie (+ 147% de revenus des m\xE9nages).\n      </p>\n      \n      <h3>Provoquer le changement social en Afrique de l\u2019Ouest</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-7-2.jpg\">\n      <i>Partenaire : Tostan | Pays : Gambie, Guin\xE9e-Bissau, S\xE9n\xE9gal\n        | Dur\xE9e : 2019-2023</i>\n      <p>\n      Le mod\xE8le collaboratif de Tostan favorise le changement social et l\u2019\xE9volution des comportements en engageant un dialogue intra et intercommunautaire approfondi pour sensibiliser jeunes, femmes, hommes, anciens et chefs religieux aux droits humains, \xE0 la sant\xE9, \xE0 l\u2019hygi\xE8ne, \xE0 la r\xE9solution de conflit, \xE0 l\u2019autonomie \xE9conomique et au r\xF4le de parent.\n      </p>\n      <p>\n      Ce travail a abouti \xE0 l\u2019un des r\xE9sultats les plus notoires \xE0 ce jour : des milliers de communaut\xE9s (8 830communaut\xE9s !) ont d\xE9clar\xE9 publiquement avoir abandonn\xE9 le mariage pr\xE9coce et la pratique de l\u2019excision.\n      </p>\n      \n      <h3>Place aux femmes dans  le secteur de la construction </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-7-3.jpg\">\n      <i>Partenaire : Buildher | Pays : Kenya | Dur\xE9e : 2019-2021</i>\n      <p>\n      En Afrique de l\u2019Est, le secteur de la construction conna\xEEt une tr\xE8s forte croissance, mais est aussi l\u2019un des plus affect\xE9s par le manque de main-d\u2019\u0153uvre qualifi\xE9e. Le programme pilote de Buildher forme des jeunes femmes d\xE9favoris\xE9es des bidonvilles de Nairobi,  en les aidant \xE0 acqu\xE9rir des comp\xE9tences tr\xE8s recherch\xE9es dans ce domaine, ainsi qu\u2019\xE0 obtenir un certificat professionnel reconnu qui leur donnera de meilleures chances de trouver un emploi stable et d\u2019\xEAtre \xE9conomiquement ind\xE9pendantes. En permettant \xE0 des femmes qualifi\xE9es d\u2019int\xE9grer le secteur de la construction, domin\xE9 par les hommes, Buildher contribue \xE0 bousculer les attitudes culturelles autour du caract\xE8re \xAB genr\xE9 \xBB  de certains secteurs d\u2019emploi au Kenya.\n      </p>\n      <p>\n      Nous soutenons Buildher pour former 400 jeunes femmes, dont au moins 320 acc\xE8deront \xE0 un emploi r\xE9mun\xE9r\xE9.\n      </p>\n    "
  }, {
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: RÉSULTATS ET  SUIVI",
    "pageIndex": 23,
    "subIndex": 0,
    "articleIndex": 8,
    "article": "\n      <h2 style=\"color:#16BECF\">R\xC9SULTATS ET  SUIVI</h2>  \n      \n      <h3>G\xE9n\xE9raliser le mod\xE8le  des M\xE8res Mentors en Ouganda </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-8-1.jpg\">\n      <i>Partenaire : mothers2mothers | Pays : Ouganda | Dur\xE9e : 2017-2019 > 2020-2023</i>\n      <p>\n      mothers2mothers forme et emploie des m\xE8res s\xE9ropositives en tant qu\u2019agents de sant\xE9 de premi\xE8re ligne. Ces M\xE8res Mentors interviennent dans les communaut\xE9s les plus d\xE9favoris\xE9es. Elles travaillent \xE0 la fois dans des centres de sant\xE9 et au sein de leurs communaut\xE9s pour prodiguer des soins aux femmes, aux enfants, aux adolescents et aux familles toutes enti\xE8res. Elles facilitent l\u2019acc\xE8s aux soins, am\xE9liorent le maintien des patients dans le syst\xE8me de sant\xE9 et assurent l\u2019adh\xE9rence au traitement en concentrant leurs efforts sur la r\xE9duction des infections au VIH (Le taux de  transmission  du VIH de la m\xE8re  \xE0 son b\xE9b\xE9 diminue de 40% \xE0 1,3%!) et aux maladies associ\xE9es.\n      </p>\n      <p>\n      Des \xE9ducatrices adolescentes travaillent aussi dans les m\xEAmes communaut\xE9s que les M\xE8res Mentors pour sensibiliser en particulier les adolescentes et les jeunes femmes aux services de sant\xE9 sexuelle et reproductive.\n      </p>\n      <p>\n      Entre 2017 et 2019, nous avons soutenu mothers2mothers pour d\xE9velopper son mod\xE8le de M\xE8res Mentors dans sept centres de sant\xE9 et dans les communaut\xE9s environnantes du centre-est de l\u2019Ouganda.\n      </p>\n      <p>\n      82 M\xE8res Mentors et 36 \xE9ducatrices adolescentes sont intervenues aupr\xE8s de 77 000 femmes et adolescentes, principalement des femmes enceintes ou allaitantes.\n      </p>\n      <p>\n      Les M\xE8res Mentors ont saisi toutes les opportunit\xE9s au sein de leurs communaut\xE9s  pour sensibiliser les familles, les informer et les encourager \xE0 faire un test de d\xE9pistage du VIH.\n      </p>\n      <p>\n      Gr\xE2ce \xE0 leur implication, 2 771 sessions de sensibilisation ont permis d\u2019informer  100 267 personnes.\n      </p>\n      <h4 class=\"article-mini-header\">2020-2023</h4>\n      <p>\n      Afin d\u2019accroitre les progr\xE8s r\xE9alis\xE9s gr\xE2ce \xE0 notre premier financement, nous renouvelons notre soutien pour renforcer l\u2019impact du mod\xE8le de M\xE8res Mentors (Pour atteindre  167 000 personnes d\xE8s la premi\xE8re ann\xE9e!) dans le centre-est de l\u2019Ouganda. mothers2mothers pourra ainsi diversifier les soins propos\xE9s et agir dans les domaines de la sant\xE9 maternelle et infantile, de l\u2019apprentissage pr\xE9coce, du handicap, ou encore de la sant\xE9 reproductive des adolescentes.\n      </p>\n      \n      <h3>Soigner les femmes souffrant  de d\xE9pression en Zambie </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-8-2.jpg\">\n      <i>Partenaire : StrongMinds | Pays : Zambie\n        | Dur\xE9e : 2018-2019 > 2020-2023</i>\n      <p>\n      La d\xE9pression est l\u2019une des maladies les plus n\xE9glig\xE9es dans les pays en voie de d\xE9veloppement. En raison du manque d\u2019attention pr\xEAt\xE9e aux troubles mentaux et des pr\xE9jug\xE9s tenaces qui y sont attach\xE9s, rares sont celles et ceux qui peuvent reconna\xEEtre leurs sympt\xF4mes et b\xE9n\xE9ficier d\u2019une prise en charge. En outre, les services de sant\xE9 mentale font cruellement d\xE9faut dans ces r\xE9gions.\n      </p>\n      <p>\n      En Ouganda, StrongMinds forme des animateurs en sant\xE9 mentale charg\xE9s d\u2019encadrer des groupes de parole : un mod\xE8le unique, simple et \xE9prouv\xE9 pour soigner les femmes souffrant de d\xE9pression au sein de communaut\xE9s d\xE9favoris\xE9es. Au terme de leur th\xE9rapie de groupe, 80 % des femmes ne souffrent plus de d\xE9pression.\n      </p>\n      <p>\n      Entre 2018 et 2019, nous avons soutenu StrongMinds afin de constituer une \xE9quipe pour r\xE9pliquer le mod\xE8le  de l\u2019Ouganda en Zambie.\n      </p>\n      <p>\n      Les r\xE9sultats sont tr\xE8s encourageants :\n      </p>\n      <p>\n      1 460 femmes vivant \xE0 Misisi, un des plus grands bidonvilles de Zambie, ont suivi la th\xE9rapie (Au terme  de la th\xE9rapie, 76,5% sont parvenues  \xE0 vaincre la  d\xE9pression) avec succ\xE8s, ce qui repr\xE9sente 20 % de plus que l\u2019objectif initial. Avec le soutien des nouveaux animateurs en sant\xE9 mentale, ces femmes ont appris \xE0 reconna\xEEtre les d\xE9clencheurs et les sympt\xF4mes de la d\xE9pression. Une fois les sympt\xF4mes d\xE9pressifs neutralis\xE9s, les participantes se nourrissent mieux, pr\xE9sentent une meilleure forme physique et prennent mieux soin de leurs enfants.\n      </p>\n      <h4 class=\"article-mini-header\">2020-2023</h4>\n      <p>\n      StrongMinds est aujourd\u2019hui en passe de devenir conseiller technique en sant\xE9 mentale aupr\xE8s du minist\xE8re zambien de la Sant\xE9. \n      </p>\n      <p>\n      Au cours des trois prochaines ann\xE9es, StrongMinds compte d\xE9velopper son mod\xE8le \xE0 travers des partenariats et l\u2019int\xE9grer progressivement au syst\xE8me national de sant\xE9. L\u2019objectif est de soigner plus de 8  000 femmes.\n      </p>\n    "
  }, {
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: RÉSULTATS",
    "pageIndex": 25,
    "subIndex": 0,
    "articleIndex": 9,
    "article": "\n      <h2 style=\"color:#16BECF\">R\xC9SULTATS</h2>  \n      \n      <h3>Des taxis conduits  par des femmes pour les femmes</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-9-1.jpg\">\n      <i>Partenaire : Azad Foundation | Pays : Inde | Dur\xE9e : 2017-2020</i>\n      <p>\n      Azad Foundation s\u2019attaque aux barri\xE8res culturelles et socio-\xE9conomiques en Inde afin d\u2019ouvrir aux femmes marginalis\xE9es l\u2019acc\xE8s \xE0 des m\xE9tiers non traditionnels.Son programme \xAB Women on Wheels \xBB s\u2019adresse aux femmes vuln\xE9rables issues de milieux d\xE9favoris\xE9s en leur offrant une formation de chauffeur professionnel.\n      </p>\n      <p>\n      En plus de l\u2019apprentissage essentiel de la conduite, cette formation couvre des domaines tels que les droits, l\u2019autod\xE9fense, l\u2019anglais, la pr\xE9sentation personnelle, l\u2019hygi\xE8ne et l\u2019\xE9ducation financi\xE8re.\n      </p>\n      <p>\n      Entre 2017 et 2020 nous avons soutenu Azad pour identifier et former des femmes vuln\xE9rables (Plus de200 ont valid\xE9  la formation) issues des quartiers les plus pauvres de Jaipur.\n      </p>\n      <p>\n      Diverses activit\xE9s ont eu lieu au sein de 225 bidonvilles pour sensibiliser les communaut\xE9s aux questions d\u2019\xE9galit\xE9 de genre.  11 346 femmes ont \xE9t\xE9 expos\xE9es \xE0 ces sessions de mobilisation.\n      </p>\n      \n      <h3>D\xE9passer le traumatisme</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-9-2.jpg\">\n      <i>Partenaire : Swiss Academy for Development | Pays : Myanmar | Dur\xE9e : 2017-2019</i>\n      <p>\n      Le Myanmar a \xE9t\xE9 le th\xE9\xE2tre de l\u2019une des guerres  civiles les plus longues que le monde ait connu.  Les femmes et les enfants en ont \xE9t\xE9 les premi\xE8res victimes. Ils souffrent aujourd\u2019hui des cons\xE9quences psychologiques de ce traumatisme et vivent dans un climat de violence latente et de peur o\xF9 silence et impunit\xE9 r\xE8gnent en ma\xEEtres. \n      </p>\n      <p>\n      Dans sept villages de Taung\xFB, Swiss Academy for Development et Karen Women Empowerment Group ont permis \xE0 des femmes et des jeunes de surmonter leur traumatisme et faire face \xE0 leur d\xE9tresse mentale \xE0 travers l\u2019activit\xE9 physique, la danse et le jeu de r\xF4le.\n      </p>\n      <p>\n      Pendant 350 sessions, 800 participants ont appris \xE0 reconna\xEEtre les signes d\u2019un traumatisme et ses effets sur leurs vies.\n      </p>\n      <p>\n      Un soutien financier a \xE9t\xE9 accord\xE9 \xE0 28 petites activit\xE9s commerciales et 8 groupes d\u2019\xE9pargne et de cr\xE9dit.\n      </p>\n      \n      <h3>Apporter de  l\u2019espoir aux femmes entrepreneurs</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-9-3.jpg\">\n      <i>Partenaire : CREA | Pays : Mexique | Dur\xE9e : 2016-2019</i>\n      <p>\n      CREA aide des femmes \xE0 d\xE9velopper leurs microentreprises \xE0 travers des formations, du mentorat et l\u2019acc\xE8s \xE0 certains services qui leur permettent d\u2019am\xE9liorer leurs m\xE9thodes de production et de distribution et de trouver de nouveaux d\xE9bouch\xE9s commerciaux. Ce programme de d\xE9veloppement commercial a \xE9t\xE9 propos\xE9 dans les centres de formation de CREA \xE0 Hidalgo, Quer\xE9taro, Yucat\xE1n, Guerrero et Toluca.\n      </p>\n      <p>\n      Plus de 7 760 femmes ont acquis des nouvelles comp\xE9tences et ont acc\xE9d\xE9 \xE0 de nouvelles sources de financement. Leurs entreprises (Taux  de survie de 82% ) ont r\xE9alis\xE9 une augmentation de 10% de leurs profits hebdomadaires.\n      </p>\n      "
  }, {
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: PROGRAMMES EN COURS",
    "pageIndex": 26,
    "subIndex": 0,
    "articleIndex": 10,
    "article": "\n      <h2 style=\"color:#16BECF\">PROGRAMMES EN COURS</h2>  \n      \n      <h3 class=\"article-mini-header\">ASIAN UNIVERSITY\n        FOR WOMEN</h3>\n        <i>Bangladesh \u2013 2018-2023 \n        </i>\n        <p>\n        20  jeunes  femmes  de  milieux  tr\xE8s  d\xE9favoris\xE9s   d\u2019Asie   re\xE7oivent   une   bourse  d\u2019\xE9tude  qui  leur  permettra  d\u2019obtenir   un   dipl\xF4me   universitaire   et  de  se  faire  une  place  dans  les  soci\xE9t\xE9s patriarcales de leur pays.\n        </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-10-1.jpg\">\n      \n      <h3 class=\"article-mini-header\">WOMEN FOR WOMEN INT. </h3>\n      <i>Kosovo et Rwanda\n        2017-2020 </i>\n        <p>\n        1 350 femmes participent \xE0 un pro-gramme    complet    d\u2019\xE9mancipation    d\u2019une   ann\xE9e   qui   leur   permet   de   sortir  de  la  pauvret\xE9  et  de  l\u2019isole-ment pour atteindre une autonomie \xE9conomique et sociale.\n        </p>\n        <img src=\"/AR2019-20/fr/static/_content/article-10-2.jpg\">\n        \n      <h3 class=\"article-mini-header\">INTERNATIONAL CENTER FOR\n        RESEARCH ON WOMEN </h3>\n        <i>Rwanda et Tanzanie\n          2019-2014 \n        </i>\n        <p>\n        Une  \xE9tude  de  terrain  est  en  cours  pour tester des strat\xE9gies d\u2019engage-ment  des  hommes  en  les  int\xE9grant  aux   programmes   traditionnels   de   soutien   \xE9conomique   et   social   des   femmes.  Women  for  Women  Int.  au  Rwanda et Hand in Hand Int. en Tan-zanie  dirigent  ces  programmes  aux-quels  900  femmes  et  470  hommes  participent.\n        </p>\n        <img src=\"/AR2019-20/fr/static/_content/article-10-3.jpg\">\n        \n      <h3 class=\"article-mini-header\">MARIE STOPES INT. </h3>\n      <i>S\xE9n\xE9gal \u2013 2019-2021 </i>\n      <p>\n      Une \xE9quipe mobile offre des services de  sant\xE9  sexuelle  et  reproductive  r\xE9guliers et gratuits \xE0 12 000 jeunes filles  et  femmes  du  nord-ouest  du  S\xE9n\xE9gal.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-10-4.jpg\">\n    "
  }, {
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES",
    "pageIndex": 27,
    "subIndex": 0,
    "articleIndex": 11,
    "article": "\n      <h2 style=\"color:#F26531\">MODES DE  SUB SISTANCE ET \xC9COSYST\xC8MES DURABLES</h2>  \n      <img src=\"/AR2019-20/fr/static/_content/article-11-1.jpg\">\n      <p>\n      Deux tiers des personnes les plus pauvres au monde vivent en zone rurale et souffrent d\u2019un manque d\u2019acc\xE8s aux march\xE9s, \xE0 l\u2019\xE9ducation, \xE0 des infrastructures de qualit\xE9, aux perspectives d\u2019emploi, aux soins m\xE9dicaux et aux produits financiers.Pour \xE9radiquer l\u2019extr\xEAme pauvret\xE9 \u2014 et la limiter \xE0 moins de 3 % de la population mondiale \u2014 nous devons en priorit\xE9 soutenir les petits fermiers partout dans le monde gr\xE2ce \xE0 des mod\xE8les \xE9prouv\xE9s qui leur permettent d\u2019acqu\xE9rir les comp\xE9tences n\xE9cessaires, un salaire d\xE9cent, une s\xE9curit\xE9 financi\xE8re afin d\u2019am\xE9liorer leur qualit\xE9 de vie.\n      </p>\n      \n    "
  }, {
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES: RÉSULTATS ET  SUIVI",
    "pageIndex": 29,
    "subIndex": 0,
    "articleIndex": 12,
    "article": "\n      <h2 style=\"color:#F26531\">R\xC9SULTATS ET  SUIVI</h2>  \n      \n      <h3>Handicap et extr\xEAme pauvret\xE9  en Ouganda  </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-12-1.jpg\">\n      <i>Partenaire : BRAC | Pays : Ouganda | Dur\xE9e : 2017-2019 > 2019-2022</i>\n      <p>\n      Les causes de la pauvret\xE9 sont multiples, c\u2019est pourquoi le programme de formation des personnes les plus pauvres de BRAC s\u2019attaque au probl\xE8me sur plusieurs fronts. Il fournit aux plus d\xE9munis des moyens de production, un soutien financier temporaire pour leur consommation journali\xE8re, un accompagnement \xE0 la cr\xE9ation d\u2019entreprise, des plans d\u2019\xE9pargne et un coaching aux aptitudes de vie, ainsi qu\u2019un acc\xE8s gratuit aux soins. En associant encadrement, transfert de connaissances et de comp\xE9tences ce programme de 24 mois aide les individus et leurs familles \xE0 sortir de l\u2019extr\xEAme pauvret\xE9.\n      </p>\n      <p>\n      Entre 2016 et 2019, nous avons soutenu l\u2019adaptation de ce programme en Ouganda,  dans les districts extr\xEAmement d\xE9favoris\xE9s de Luwero et Kiryandongo.\n      </p>\n      <p>\n      1   650 jeunes parmi les plus d\xE9munis ne sont plus en situation de pauvret\xE9 extr\xEAme et disposent de moyens de subsistance p\xE9rennes.\n      </p>\n      <p>\n      Ils ont am\xE9lior\xE9 objectivement leurs revenus, leur consommation,  leurs moyens de production, leur s\xE9curit\xE9 alimentaire et leur sant\xE9,  et ont fait de m\xEAme pour leurs familles (8 250  personnes  au total).\n      </p>\n      <p>\n      Le programme est ax\xE9 sur l\u2019incitation \xE0 l\u2019\xE9pargne chez les jeunes. La formation financi\xE8re donne aux participants les connaissances et les outils n\xE9cessaires pour g\xE9rer leur argent et planifier leur avenir : 100 associations villageoises d\u2019\xE9pargne et de cr\xE9dit (Les montants \xE9pargn\xE9s ont  augment\xE9 de 56,7%) ont \xE9t\xE9 mises sur pied.\n      </p>\n\n      <h4 class=\"article-mini-header\">2019-2022</h4>\n      <p>\n      Nous maintenons notre soutien \xE0 BRAC en Ouganda, o\xF9 l\u2019organisation m\xE8ne un projet pilote de formation \xE0 destination des plus d\xE9munis adapt\xE9 aux personnes handicap\xE9es en partenariat avec Handicap International et la National Union of Women with Disabilities of Uganda. Ensemble, ils devraient permettre \xE0 2 700 personnes et leurs familles de sortir de la pauvret\xE9.\n      </p>\n      \n      <h3>Tracer la voie pour sortir de la pauvret\xE9 </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-12-2.jpg\">\n      <i>Partenaire : Village Enterprise | Pays : Ouganda\n        | Dur\xE9e :  2016-2019 > 2020-2023 </i>\n      <p>\n      Le programme de formation \xE0 la cr\xE9ation de microentreprises de Village Enterprise a d\xE9j\xE0 d\xE9montr\xE9 son efficacit\xE9 : il permet de sortir les personnes de la pauvret\xE9 extr\xEAme en les aidant \xE0 d\xE9velopper  des moyens de subsistance durables.\n      </p>\n      <p>\n      Les participants, identifi\xE9s suite \xE0 un classement socio-\xE9conomique participatif, b\xE9n\xE9ficient  d\u2019une aide financi\xE8re, de formations en entrepreneuriat et finance, et d\u2019un mentorat continu avec  un entrepreneur local. Ils re\xE7oivent aussi un soutien \xE0 la cr\xE9ation de petites activit\xE9s commerciales  et \xE0 la formation de groupes d\u2019\xE9pargne et de cr\xE9dit.\n      </p>\n      <p>\n      Entre 2016 et 2019, 900 entreprises (55%  ont augment\xE9  leur valeur) de trois personnes ont \xE9t\xE9 cr\xE9\xE9es,  ainsi que 90 groupes d\u2019\xE9pargne (311%  d\u2019augmentation  de l\u2019\xE9pargne  des foyers), ce qui a permis \xE0 2 700 personnes d\u2019acc\xE9der  \xE0 l\u2019autonomie sociale et \xE9conomique.\n      </p>\n      <h4 class=\"article-mini-header\">2020-2023</h4>\n      <p>\n      Nous renouvelons notre soutien \xE0 Village Enterprise en Ouganda avec l\u2019objectif de fournir \xE0 2   700 personnes parmi les plus d\xE9munies, principalement des femmes, les connaissances, les comp\xE9tences et la confiance n\xE9cessaires pour d\xE9velopper des microentreprises durables.\n      </p>\n\n      <h3>Des agriculteurs prosp\xE8res, des communaut\xE9s dynamiques</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-12-3.jpg\">\n      <i>Partenaire : One Acre Fund | Pays : Rwanda\n        | Dur\xE9e :  2016-2019 > 2020-2023 </i>\n      <p>\n      Le dynamisme des communaut\xE9s rurales repose sur des petits agriculteurs solides. One Acre Fund propose aux fermiers d\u2019Afrique de l\u2019Est un ensemble de services, dont des semences et engrais am\xE9lior\xE9s, des financements ainsi que des formations et un acc\xE8s au march\xE9. Ces services les aident  \xE0 augmenter leurs rendements sur une saison et, donc, leur qualit\xE9 de vie.\n      </p>\n      <p>\n      Entre 2016 et 2019, les actions de One Acre Fund ont permis \xE0  390 000 fermiers rwandais d\u2019augmenter leurs  revenus de 120 dollars en moyenne par an (Pr\xE8s de50% de femmes), am\xE9liorant  ainsi la qualit\xE9 de vie de plus de 2 millions de personnes. Au fil des ans, les \xE9quipes de One Acre Fund ont \xE9tabli de bonnes relations de travail avec les autorit\xE9s rwandaises nationales et locales pour  pr\xE9parer l\u2019expansion de leur mod\xE8le.\n      </p>\n      <h4 class=\"article-mini-header\">2019-2023</h4>\n      <p>\n      Pour capitaliser sur ces r\xE9sultats encourageants, nous financerons les activit\xE9s de One Acre Fund pour trois ann\xE9es suppl\xE9mentaires, et ainsi permettre \xE0 l\u2019organisation d\u2019am\xE9liorer la vie d\u20191,5 million de fermiers (1/3 des familles de  petits agriculteurs  du pays) d\u2019ici 2022.\n      </p>\n\n      <h3>Plus de prosp\xE9rit\xE9  pour les petits fermiers </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-12-4.jpg\">\n      <i>Partenaire : Root Capital | Pays : P\xE9rou\n        | Dur\xE9e : 2016-2019 > 2019-2022 </i>\n      <p>\n      Les petites entreprises agricoles et les coop\xE9ratives peuvent \xEAtre de puissants moteurs de prosp\xE9rit\xE9. Lorsqu\u2019elles se d\xE9veloppent et s\u2019\xE9panouissent, les centaines de petits agriculteurs qui y sont associ\xE9s prosp\xE8rent et deviennent plus r\xE9silients. En effet, ces entreprises ne fournissent pas seulement des moyens vitaux de subsistance, elles agissent aussi comme des catalyseurs de changement en introduisant des pratiques \xE9co-responsables, en investissant dans l\u2019infrastructure locale, en connectant les familles de fermiers \xE0 des march\xE9s plus \xE9tendus et en renfor\xE7ant les communaut\xE9s locales gr\xE2ce \xE0 des emplois, des formations et de meilleurs revenus. \n      </p>\n      <p>\n      Le mod\xE8le \xAB cr\xE9dit plus comp\xE9tences \xBB de Root Capital permet d\u2019accorder des pr\xEAts aux entreprises qui sont trop grandes pour les institutions de microfinance, mais souvent trop petites et \xE0 risque pour obtenir des pr\xEAts traditionnels aupr\xE8s des banques commerciales. Ce soutien financier s\u2019accompagne de formations agronomiques et de conseils financiers sur la bonne gestion des pr\xEAts, ainsi que de meilleures connexions avec les march\xE9s.\n      </p>\n      <p>\n      Entre 2016 et 2019, nous avons soutenu les efforts de Root Capital pour r\xE9duire la pauvret\xE9 rurale au P\xE9rou. En trois ans :\n      </p>\n      <p>\n      62 coop\xE9ratives rurales (Hausse moyenne de  27%  des revenus) ont re\xE7u des pr\xEAts et des conseils financiers.\n      </p>\n      <p>\n      Plus de 33 500 petits exploitants (Dont6  329    femmes) ont augment\xE9 leurs revenus de 16%, am\xE9liorant ainsi les conditions de vie de plus de 165 000 membres de leur famille.\n      </p>\n      <p>\n      Grace \xE0 la pratique de l\u2019agriculture biologique, de la reforestation  et de la diversification agricole 52 115 hectares de terre ont \xE9t\xE9  g\xE9r\xE9s durablement.\n      </p>\n\n      <h4 class=\"article-mini-header\">2019-2022</h4>\n      <p>\n      Apr\xE8s une premi\xE8re subvention de trois ans, nous renouvelons notre collaboration avec Root Capital au P\xE9rou afin d\u2019offrir des financements sur-mesure et une assistance technique essentielle \xE0 95 coop\xE9ratives rurales, ce qui b\xE9n\xE9ficiera \xE0 environ 30  000 petits agriculteurs.\n      </p>\n\n      <h3>D\xE9velopper une serre r\xE9volutionnaire </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-12-5.jpg\">\n      <i>Partenaire : Kheyti | Pays : Inde\n        | Dur\xE9e :  2018-2019 > 2019-2022</i>\n      <p>\n      L\u2019agriculture indienne est de moins en moins rentable et de plus en plus sensible au climat, alors que le pays entier en d\xE9pend pour se nourrir et qu\u2019elle constitue la premi\xE8re source d\u2019emploi de la population.\n      </p>\n      <p>\n      Kheyti con\xE7oit, produit et vend \xE0 un prix abordable des serres modulaires innovantes. L\u2019organisation propose \xE9galement des services de financement, d\u2019acc\xE8s aux intrants et aux march\xE9s, et des formations pour am\xE9liorer les cultures, la r\xE9colte et la vente des produits mara\xEEchers.\n      </p>\n      <p>\n      Kheyti est la seule entreprise \xE0 offrir aux petits fermiers cette solution de serre tout-en-un.Nous avons financ\xE9 les activit\xE9s de Kheyti, initialement sur une ann\xE9e, afin que l\u2019entreprise puisse d\xE9montrer l\u2019efficacit\xE9 de son mod\xE8le. \n      </p>\n      <p>\n      Durant cette p\xE9riode, la \xAB Greenhouse-in-a-box \xBB a permis \xE0 50 petits fermiers de multiplier leurs r\xE9coltes par 7 en \xE9conomisant 90% d\u2019eau. D\xE9sormais, 125 fermiers  sont \xE9quip\xE9s de la serre d\xE9velopp\xE9e par Kheyti\n      </p>\n      <h4 class=\"article-mini-header\">2019-2022</h4>\n      <p>\n      Nous soutenons Kheyti pour lui permettre d\u2019am\xE9liorer davantage son produit et ses services  tout en se d\xE9veloppant pour servir 10  000 petits fermiers d\u2019ici 2022.\n      </p>\n    "
  }, {
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES: RÉSULTATS",
    "pageIndex": 34,
    "subIndex": 0,
    "articleIndex": 13,
    "article": "\n      <h2 style=\"color:#F26531\">R\xC9SULTATS</h2>  \n      \n      <h3>Former des  microentrepreneurs,  investir dans leur avenir  </h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-13-1.jpg\">\n      <i>Partenaire : IECD | Pays : Madagascar | Dur\xE9e : 2017-2019</i>\n      <p>\n      \xC0 Madagascar, les microentreprises informelles constituent la source principale de revenus pour la majorit\xE9 de la population non agricole. Mais souvent  les microentrepreneurs ne disposent pas de comp\xE9tences en gestion et de la vision \xE0 moyen terme n\xE9cessaires au maintien de leurs activit\xE9s au-del\xE0 de la premi\xE8re ann\xE9e.\n      </p>\n      <p>\n      Au cours des trois derni\xE8res ann\xE9es, l\u2019IECD, en partenariat avec l\u2019ONG locale Madagascar Enterprise Development, a offert \xE0 320 cr\xE9ateurs et responsables de petites entreprises une formation de base en gestion ainsi qu\u2019un suivi personnalis\xE9 afin de leur permettre d\u2019\xE9valuer la faisabilit\xE9 de leurs projets et de p\xE9renniser leurs activit\xE9s (57% de participants ont augment\xE9 leurs revenus et  79% ont commenc\xE9  \xE0 \xE9pargner), les rendant ainsi plus rentables.\n      </p>\n      <p>\n      De plus, 75 microentrepreneurs extr\xEAmement vuln\xE9rables \u2013 vendeurs de rue et entrepreneurs illettr\xE9s \u2013 ont \xE9galement appris les principes de base de gestion, ce qui les a aid\xE9s \xE0 stabiliser leurs revenus.\n      </p>\n      "
  }, {
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES: PROGRAMMES EN COURS",
    "pageIndex": 35,
    "subIndex": 0,
    "articleIndex": 14,
    "article": "\n      <h2 style=\"color:#F26531\">PROGRAMMES EN COURS</h2>  \n      \n      <h3 class=\"article-mini-header\">BLUE VENTURES \n      </h3>\n        <i>Madagascar \u2013 2018-2021 </i>\n        <p>\n        Des  communaut\xE9s  de  p\xEAcheurs  s\u2019engagent   dans   la   gestion   de   leurs  ressources  avec  des  fer-metures  temporaires  de  zones  de   p\xEAche   permettant   aux   in-vert\xE9br\xE9s  de  se  reconstituer  et  aux  p\xE9cheurs  d\u2019augmenter  leurs  prises et leurs revenus.\n        </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-14-1.jpg\">\n      \n      <h3 class=\"article-mini-header\">PROXIMITY DESIGNS \n      </h3>\n      <i>Myanmar \u2013 2018-2020</i>\n        <p>\n        L\u2019acc\xE8s aux nouvelles techniques d\u2019irrigation   am\xE9liore   les   condi-tions  de  vie  de  30  000  fermiers  du  delta  d\u2019Ayeyarwady  et  de  la  Zone s\xE8che du centre du pays.\n        </p>\n        <img src=\"/AR2019-20/fr/static/_content/article-14-2.jpg\">\n        \n      <h3 class=\"article-mini-header\">MYAGRO</h3>\n        <i>S\xE9n\xE9ga \u2013 2019-2022</i>\n        <p>\n        Les   cartes   pr\xE9pay\xE9es   myAgro   permettent  \xE0  75  000  fermiers  dans   528   villages   du   S\xE9n\xE9gal   de   payer   par   petites   tranches les    intrants    agricoles    et    les    formations  dont  ils  ont  besoin,  augmentant  ainsi  leurs  r\xE9coltes  en moyenne de 50%.\n        </p>\n        <img src=\"/AR2019-20/fr/static/_content/article-14-3.jpg\">\n        \n      <h3 class=\"article-mini-header\">EDUCATION\n        FOR EMPLOYMENT </h3>\n      <i>Maroc  \u2013 2019-2020</i>\n      <p>\n      430  jeunes  Marocains  acqui\xE8rent  des   comp\xE9tences   techniques   et   commerciales  et  des  aptitudes  de  vie  pour  augmenter  leurs  chancesde d\xE9crocher des postes \xE0 responsa-bilit\xE9   et   de   s\u2019assurer   des   revenus   suffisants.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-14-4.jpg\">\n        \n      <h3 class=\"article-mini-header\">TERRE DES HOMMES SUISSE </h3>\n      <i>P\xE9rou \u2013 2017-2020</i>\n      <p>\n      Une  coop\xE9rative  de  cacao  de  la  r\xE9gion    amazonienne    cr\xE9\xE9e    par    d\u2019anciens   orpailleurs   s\u2019attache   \xE0   am\xE9liorer  sa  production  agricole,  consolider ses strat\xE9gies de vente et   ses   pratiques   de   gestion,   et   atteindre l\u2019autosuffisance.\n      </p>\n      <img src=\"/AR2019-20/fr/static/_content/article-14-5.jpg\">\n    "
  }, {
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE",
    "pageIndex": 37,
    "subIndex": 0,
    "articleIndex": 15,
    "article": "\n      <h2 style=\"color:#009B8C\">R\xC9PONSE ET  PR\xC9 PARATION AUX SITUATIONS D\u2019URGENCE</h2>  \n      <img src=\"/AR2019-20/fr/static/_content/article-15-1.jpg\">\n      <p>\n      Alors que le monde est aux prises avec la plus grande crise sanitaire depuis un si\xE8cle, personne ne doit \xEAtre laiss\xE9 pour compte. D\u2019autres \xE9pid\xE9mies mortelles continuent de faire des ravages, notamment celles d\u2019Ebola ou de la rougeole en R\xE9publique d\xE9mocratique du Congo. Les services de sant\xE9 essentiels, en particulier dans les environnements difficiles comme les camps de r\xE9fugi\xE9s, doivent \xEAtre maintenus pour sauver des vies et pr\xE9server  la dignit\xE9 de chacun.\n      </p>\n      \n    "
  }, {
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE: NOUVEAUX PROGRAMMES ",
    "pageIndex": 39,
    "subIndex": 0,
    "articleIndex": 16,
    "article": "\n      <h2 style=\"color:#009B8C\">NOUVEAUX PROGRAMMES </h2>  \n      \n      <h3>Sauver des vies,  prot\xE9ger des droits</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-16-1.jpg\">\n      <i>Partenaire : SOS M\xC9DITERRAN\xC9E | Pays : Mer M\xE9diterran\xE9e | Dur\xE9e : 2019-2020</i>\n      <p>\n      Au cours des six derni\xE8res ann\xE9es, plus de 20 000 personnes ont p\xE9ri ou ont disparu en mer entre la Libye et les c\xF4tes m\xE9ridionales de l\u2019Europe, la voie de migration la plus mortelle au monde.\n      </p>\n      <p>\n      SOS M\xC9DITERRAN\xC9E est une organisation d\u2019aide humanitaire qui depuis 2019 a affr\xE9t\xE9 le navire de sauvetage Ocean Viking. Elle a pour mission de sauver les personnes  en d\xE9tresse en mer, porter assistance aux survivants \xE0 bord  et t\xE9moigner des r\xE9alit\xE9s de la migration dans la r\xE9gion.\n      </p>\n      <p>\n      La filiale suisse s\u2019attache particuli\xE8rement au cadre juridique qui vise \xE0 clarifier et actualiser le droit international en mati\xE8re de droits humains en milieu marin.\n      </p>\n      <p>\n      Depuis le d\xE9but de ses op\xE9rations, SOS M\xC9DITERRAN\xC9E  a port\xE9 secours \xE0 31 799 survivants.\n      </p>\n      \n      <h3>Soigner dans des contextes d\u2019ins\xE9curit\xE9</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-16-2.jpg\">\n      <i>Partenaire : M\xE9decins Sans Fronti\xE8res (MSF) | Pays : R\xE9publique D\xE9mocratique du Congo, Niger\n        | Dur\xE9e : 2019-2020</i>\n        <p>185 800 enfants ont  \xE9t\xE9 vaccin\xE9s</p>\n      <p>\n      En RDC, MSF intervient dans des zones marqu\xE9es par des difficult\xE9s logistiques et l\u2019ins\xE9curit\xE9 pour r\xE9pondre \xE0 deux importantes \xE9pid\xE9mies d\u2019Ebola et de rougeole. \n      </p>\n      <p>\n      L\u2019\xE9pid\xE9mie d\u2019Ebola qui a s\xE9vit dans les provinces du Nord-Kivu, Sud-Kivu et Ituri en 2018 a \xE9t\xE9 la pire jamais enregistr\xE9e dans le pays, avec 3 324 cas confirm\xE9s et 2 287 morts.Nous avons soutenu MSF afin d\u2019offrir des soins gratuits \xE0 1 036 patientsdans le centre de traitement Ebola de Bunia.\n      </p>\n      <p>\n      Une \xE9pid\xE9mie massive de rougeole ravage aussi le pays depuis mi-2018. 310 000 personnes ont \xE9t\xE9 infect\xE9es et 6 000 sont mortes au cours de la seule ann\xE9e 2019.\n      </p>\n      <p>\n      Les \xE9quipes de MSF ont trait\xE9 13 800 patients et ont mis en place un laboratoire d\u2019analyses et des activit\xE9s de surveillance pour circonscrire l\u2019\xE9pid\xE9mie.\n      </p>\n      <p>\n      Au Niger, MSF a fourni des soins de qualit\xE9 \xE0 16 300 enfants dans l\u2019unit\xE9 p\xE9diatrique de l\u2019h\xF4pital de Magaria. En 2019 plus de 45 000 enfants ont aussi re\xE7u une assistance m\xE9dicale dans les communaut\xE9s environnantes.       \n      </p>\n    "
  }, {
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE: RÉSULTATS ",
    "pageIndex": 40,
    "subIndex": 0,
    "articleIndex": 17,
    "article": "\n      <h2 style=\"color:#009B8C\">R\xC9SULTATS </h2>  \n      \n      <h3>Des services de sant\xE9  p\xE9rennes \xE0 Cox Bazar</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-17-2.jpg\">\n      <i>Partenaire : BRAC | Pays : Bangladesh | Dur\xE9e : 2018-2020</i>\n      <p>\n      Alors que la situation d\u2019urgence dans les camps de r\xE9fugi\xE9s de Cox Bazar s\u2019est mu\xE9e en crise humanitaire prolong\xE9e, nous avons soutenu BRAC pour r\xE9nover et am\xE9liorer un centre de sant\xE9 et deux dispensaires. Ces structures sanitaires offrent des services essentiels de qualit\xE9, en particulier dans le domaine de la sant\xE9 sexuelle et reproductive, la sant\xE9 n\xE9onatale et infantile, dans la pr\xE9vention de maladies non transmissibles et la sant\xE9 mentale.\n      </p>\n      <p>\n      L\u2019acc\xE8s \xE0 des infrastructures am\xE9lior\xE9es repr\xE9sente une importante avanc\xE9e dans un contexte extr\xEAmement fragile et pr\xE9caire. Entre avril 2019 et f\xE9vrier 2020 les \xE9quipes de BRAC ont assur\xE9 334 000 consultations m\xE9dicales, 2 300 accouchements s\xE9curis\xE9s et  14 000 consultations de planification familiale. Les \xE9quipes m\xE9dicales de BRAC ont d\xFB faire face \xE0 un nombre croissant de cas critiques de rougeole et cholera n\xE9cessitant des soins intensifs.\n      </p>\n      <p>\n      140 000 r\xE9fugi\xE9s ont eu acc\xE8s \xE0 des soins de qualit\xE9\n      </p>\n    "
  }, {
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE: RÉSULTATS - COVID-19 ",
    "pageIndex": 40,
    "subIndex": 0,
    "articleIndex": 18,
    "article": "\n      <h2 style=\"color:#009B8C\">R\xC9SULTATS </h2>  \n\n      <h3>Soutenir la r\xE9ponse  \xE0 l\u2019\xE9pid\xE9mie de  COVID-19 en Europe</h3>\n      <img src=\"/AR2019-20/fr/static/_content/article-17-1.jpg\">\n      <i>Partenaire : M\xE9decins Sans Fronti\xE8res (MSF) | Pays : Belgique, Espagne, France, Gr\xE8ce, Italie, Suisse\n        | Dur\xE9e : 2020</i>\n      <p>\n      Face \xE0 la propagation de l\u2019\xE9pid\xE9mie de coronavirus en Europe, nous avons soutenu les \xE9quipes de MSF afin d\u2019aider les autorit\xE9s sanitaires nationales et renforcer leurs capacit\xE9s de pr\xE9vention, contr\xF4le et traitement des cas.\n      </p>\n      <p>\n      Les activit\xE9s de MSF se sont concentr\xE9es sur les populations en situation pr\xE9caire telles que les r\xE9sidents des maisons de retraite, les sans domicile fixe, les migrants, les demandeurs d\u2019asile, les d\xE9tenus et le personnel p\xE9nitentiaire.Des \xE9quipes mobiles ont proc\xE9d\xE9 \xE0 des activit\xE9s de consultation et d\xE9pistage, ainsi que de diagnostic, d\u2019isolement et de prise en charge des cas dans des structures d\u2019h\xE9bergement d\xE9di\xE9es.\n      </p>\n      <p>\n      MSF a par ailleurs fourni un soutien psychologique aux travailleurs de sant\xE9 de premi\xE8re ligne.\n      </p>\n    "
  }] });
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
          //  if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
          // if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
          //  if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
          //  if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changePageSize: function changePageSize(context, payload) {
    var pageWidth = context.getters.width;
    if (context.getters.currentPage.pageIndex == 0) {
      context.commit('UPDATE_IS_FRONT_PAGE', true);
    } else {
      context.commit('UPDATE_IS_FRONT_PAGE', false);
    }
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    // console.log(widthRatio)
    // console.log(pageWidth)
    var heightRatio = windowHeight / pageHeight;
    // console.log(heightRatio)
    // console.log(pageHeight)
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio && context.getters.zeroedPageIndex != 0) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openArticle: function openArticle(context, payload) {
    context.commit('OPEN_ARTICLE', payload);
    context.dispatch('syncPage', context.getters.articles[payload].pageIndex);
  },
  closeArticle: function closeArticle(context, payload) {
    context.commit('CLOSE_ARTICLE');
  },


  goToArticle: function goToArticle(context, payload) {
    return context.dispatch('openArticle', payload);
  },
  goToPreviousArticle: function goToPreviousArticle(context) {
    return context.dispatch('openArticle', context.getters.previousArticleIndex);
  },
  goToNextArticle: function goToNextArticle(context) {
    return context.dispatch('openArticle', context.getters.nextArticleIndex);
  },

  increaseArticleFontSize: function increaseArticleFontSize(context, payload) {
    return context.commit('INCREASE_ARTICLE_FONT_SIZE', payload);
  },
  decreaseArticleFontSize: function decreaseArticleFontSize(context, payload) {
    return context.commit('DECREASE_ARTICLE_FONT_SIZE', payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  isArticle: function isArticle(state) {
    return state.isArticle;
  },
  articleFontSize: function articleFontSize(state) {
    return state.articleFontSize;
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length - 1) return null;
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    } else {
      if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  },

  //#endregion

  //#region doublePage

  //#endregion

  articles: function articles(state) {
    return state.document.articles;
  },
  articlesEnabled: function articlesEnabled(state) {
    return state.document.options.articlesEnabled;
  },
  currentArticle: function currentArticle(state, getters) {
    if (!getters.isArticle) return;
    return getters.articles[state.articleIndex];
  },
  nextArticle: function nextArticle(state, getters) {
    if (!getters.isArticle) return;
    if (getters.currentArticle.articleIndex == getters.articles.length - 1) {
      return getters.articles[state.articleIndex];
    }
    return getters.articles[state.articleIndex + 1];
  },
  previousArticle: function previousArticle(state, getters) {
    if (!getters.isArticle) return;
    if (getters.currentArticle.articleIndex == 0) {
      return getters.articles[state.articleIndex];
    }
    return getters.articles[state.articleIndex - 1];
  },
  previousArticleIndex: function previousArticleIndex(state, getters) {
    if (getters.previousArticle) {
      return getters.previousArticle.articleIndex;
    }
    return null;
  },
  nextArticleIndex: function nextArticleIndex(state, getters) {
    if (getters.nextArticle) {
      return getters.nextArticle.articleIndex;
    }
    return null;
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_FRONT_PAGE, function (state, payload) {
  console.log(payload);
  if (payload) {
    state.document.width = 1448;
    console.log(state.document.width);
  } else {
    state.document.width = 724;
    console.log(state.document.width);
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, OPEN_ARTICLE, function (state, payload) {
  state.isArticle = true;
  state.articleIndex = payload;
  // document.getElementsByClassName('article-content')[0].scrollIntoView(true)
}), defineProperty_default()(_types$RESET_SECTION_, CLOSE_ARTICLE, function (state, payload) {
  state.isArticle = false;
}), defineProperty_default()(_types$RESET_SECTION_, INCREASE_ARTICLE_FONT_SIZE, function (state, payload) {
  var x = document.getElementById('article-container');
  x.style.fontSize = state.articleFontSize.toString() + "em";
  if (state.articleFontSize < 1.6) {
    state.articleFontSize += .2;
  }
  x.style.fontSize = state.articleFontSize.toString() + "em";
}), defineProperty_default()(_types$RESET_SECTION_, DECREASE_ARTICLE_FONT_SIZE, function (state, payload) {
  var x = document.getElementById('article-container');
  x.style.fontSize = state.articleFontSize.toString() + "em";
  if (state.articleFontSize > 1) {
    state.articleFontSize -= .2;
  }
  x.style.fontSize = state.articleFontSize.toString() + "em";
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isArticle: false,
    articleIndex: 0,
    articleFontSize: 1
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      // if(Publish.isMobile && document.documentElement.dataset.mobile == "iOS") {
      //   console.log("HAMMER SWIPE")
      //   // var element = document.querySelector('.article-page');
      //   console.log(window.innerWidth);
      //   console.log(e.center.x - e.deltaX)
      //   if ((e.center.x - e.deltaX) < 30 || (e.center.x - e.deltaX) > window.innerwidth - 30) {
      //     // prevent swipe to navigate gesture
      //     e.preventDefault();
      //   }
      // } else 
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.isArticle && !Publish.isZoomed) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.goToNextArticle();
            } else {
              Publish.goToPreviousArticle();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.goToPreviousArticle();
            } else {
              Publish.goToNextArticle();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isArticle) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.goToPreviousArticle();
        } else {
          Publish.goToNextArticle();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.goToNextArticle();
        } else {
          Publish.goToPreviousArticle();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-159440454-19',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL", "isArticle", "nextArticle", "previousArticle", "currentArticle", "showArticles", "articlesEnabled"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio", "openArticle", "closeArticle", "goToArticle", "goToNextArticle", "goToPreviousArticle"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7QL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIzX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nPlW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.51c187467ffd8c45b0e7.js